const arrays = [];

arrays["sexo"] = [
    { id: 1, value: "Masculino" },
    { id: 2, value: "Feminino" },
    { id: 3, value: "Intersexo" },
];

arrays["genero"] = [
    { id: 1, value: "Transmasculino" },
    { id: 2, value: "Transfeminino" },
    { id: 3, value: "Não-binário" },
    { id: 4, value: "Cisgênero" },
    { id: 5, value: "Travestis" },
    { id: 6, value: "Outros" },
];

arrays["substancias_psicoativas"] = [
    { id: 1, value: "Somente álcool" },
    { id: 2, value: "Somente maconha" },
    { id: 3, value: "Somente cocaína" },
    { id: 4, value: "Somente crack" },
    { id: 5, value: "Múltiplas" },
    { id: 6, value: "Não faz uso de álcool ou drogas" },
];

arrays["violacoesDireitos"] = [
    { id: 1, value: "TRABALHO INFANTOJUVENIL" },
    { id: 2, value: "EXPLORAÇÃO SEXUAL" },
    { id: 3, value: "ABUSO SEXUAL" },
    { id: 4, value: "VIOLÊNCIA FÍSICA" },
    { id: 5, value: "VIOLÊNCIA PSICOLÓGICA" },
    { id: 6, value: "NEGLIGÊNCIA" },
    { id: 7, value: "ABANDONO" },
    { id: 8, value: "TRAJETÓRIA DE RUA" },
    { id: 9, value: "TRÁFICO DE PESSOAS" },
    { id: 10, value: "VIOLÊNCIA PATRIMONIAL CONTRA A PESSOA IDOSA OU PESSOA COM DEFICIÊNCIA" },
    { id: 11, value: "AFASTAMENTO DO CONVÍVIO FAMILIAR DEVIDO À APLICAÇÃO DE MEDIDA SOCIOEDUCATIVA" },
    { id: 12, value: "AFASTAMENTO DO CONVÍVIO FAMILIAR DEVIDO À APLICAÇÃO DE MEDIDA DE PROTEÇÃO" },
    { id: 13, value: "DISCRIMINAÇÃO EM DECORRÊNCIA DA ORIENTAÇÃO SEXUAL" },
    { id: 14, value: "DISCRIMINAÇÃO EM DECORRÊNCIA DA RAÇA/ETNIA" },
    { id: 15, value: "DESCUMPRIMENTO DE CONDICIONALIDADES DO PBF E DO PETI EM OCORRÊNCIA DE VIOLAÇÕES DE DIREITOS" },
    { id: 16, value: "EXPLORAÇÃO DA IMAGEM" },
    { id: 17, value: "FAMÍLIAS COM MEMBROS EM SITUAÇÃO DE DESAPARECIMENTO" },
    { id: 18, value: "VIOLÊNCIA MORAL" },
    { id: 19, value: "VIOLÊNCIA INSTITUCIONAL" },
    { id: 20, value: "BULLYING" },
    { id: 21, value: "PORNOGRAFIA INFANTOJUVENIL" },
    { id: 22, value: "TRÁFICO E VENDA DE PESSOAS PARA FINS DE EXPLORAÇÃO SEXUAL" },
    { id: 23, value: "TURISMO COM MOTIVAÇÃO SEXUAL" },
    { id: 24, value: "PROSTITUIÇÃO INFANTOJUVENIL" },
    { id: 25, value: "SITUAÇÃO DE REFÚGIO" },
];

arrays["cor_raca"] = [
    { id: "1", value: "Branca" },
    { id: "2", value: "Preta" },
    { id: "3", value: "Amarela" },
    { id: "4", value: "Parda" },
    { id: "5", value: "Não declarado" },
];

arrays["tipo_deficiencia"] = [
  { id: "1", value: "Deficiência Física" },
  { id: "2", value: "Deficiência Auditiva" },
  { id: "3", value: "Deficiência Visual" },
  { id: "4", value: "Deficiência Intelectual" },
  { id: "5", value: "Deficiência Psicossocial (Transtorno Mental)" },
  { id: "6", value: "Transtorno do Espectro Autista (TEA)" },
  { id: "7", value: "Outras" }, // sempre a última
];

arrays["cor_raca_acolhimento"] = [
    { id: 1, value: "Branca" },
    { id: 2, value: "Preta" },
    { id: 3, value: "Amarela" },
    { id: 4, value: "Parda" },
    { id: 5, value: "Não declarado" },
];

arrays["etnia"] = [
    { id: 1, value: "Indígena" },
    { id: 2, value: "Quilombola" },
    { id: 3, value: "Outra" },
    { id: 4, value: "Não declarada" }, 
];

arrays["estados"] = [
    { id: "AC", value: "Acre" },
    { id: "AL", value: "Alagoas" },
    { id: "AP", value: "Amapá" },
    { id: "AM", value: "Amazonas" },
    { id: "BA", value: "Bahia" },
    { id: "CE", value: "Ceará" },
    { id: "DF", value: "Distrito Federal" },
    { id: "ES", value: "Espírito Santo" },
    { id: "GO", value: "Goías" },
    { id: "MA", value: "Maranhão" },
    { id: "MT", value: "Mato Grosso" },
    { id: "MS", value: "Mato Grosso do Sul" },
    { id: "MG", value: "Minas Gerais" },
    { id: "PA", value: "Pará" },
    { id: "PB", value: "Paraíba" },
    { id: "PR", value: "Paraná" },
    { id: "PE", value: "Pernambuco" },
    { id: "PI", value: "Piauí" },
    { id: "RJ", value: "Rio de Janeiro" },
    { id: "RN", value: "Rio Grande do Norte" },
    { id: "RS", value: "Rio Grande do Sul" },
    { id: "RO", value: "Rondônia" },
    { id: "RR", value: "Roraíma" },
    { id: "SC", value: "Santa Catarina" },
    { id: "SP", value: "São Paulo" },
    { id: "SE", value: "Sergipe" },
    { id: "TO", value: "Tocantins" },
];
arrays["programas"] = [
    { id: 1, value: "PROGRAMA BOLSA FAMÍLIA (PBF)" },
    { id: 2, value: "BPC" },
    { id: 3, value: "PETI" },
    { id: 4, value: "Criança Feliz" },
    { id: 5, value: "Outro(s) Programa(s) prioritário(s)" },
];

arrays["forma_ingresso_cad"] = [
    { id: 0, value: "Informação migrada como inexistente" },
    { id: 1, value: "Posto de Atendimento / CRAS" },
    { id: 2, value: "Em domicílio" },
];

arrays["forma_ingresso"] = [
    { id: 1, value: "Por demanda espontânea" },
    {
        id: 2,
        value: "Em decorrência de Busca Ativa realizada pela equipe da unidade",
    },
    {
        id: 3,
        value: "Em decorrência de Abordagem Social realizada pela equipe da unidade",
    },
    {
        id: 4,
        value: "Em decorrência de encaminhamento realizado por outros serviços/unidades da Proteção Social Básica",
    },
    {
        id: 5,
        value: "Em decorrência de encaminhamento realizado por outros serviços/unidades da Proteção Social Especial",
    },
    {
        id: 6,
        value: "Em decorrência de encaminhamento realizado pela área de Saúde",
    },
    {
        id: 7,
        value: "Em decorrência de encaminhamento realizado pela área de Educação",
    },
    {
        id: 8,
        value: "Em decorrência de encaminhamento realizado outras políticas setoriais",
    },
    {
        id: 9,
        value: "Em decorrência de encaminhamento realizado pelo Conselho Tutelar",
    },
    {
        id: 10,
        value: "Em decorrência de encaminhamento realizado pelo Poder Judiciário",
    },
    {
        id: 11,
        value: "Em decorrência de encaminhamento realizado pelo Sistema de Garantia de Direitos (Defensoria Pública, Ministério Público, Delegacias)",
    },
    { id: 12, value: "Outros encaminhamentos" },
];

arrays["pergunta"] = [
    { id: 1, value: "SIM" },
    { id: 2, value: "NÃO" },
];
arrays["perguntas"] = [
    { id: "1", value: "SIM" },
    { id: "2", value: "NÃO" },
];
arrays["pergunta_dependente_cuidados"] = [
    { id: 1, value: "SIM" },
    { id: 2, value: "NÃO" },
    { id: 3, value: "Não se aplica (família sem pessoa idosa)" },
];
arrays["pergunta_cri_ado_acesso_lazer"] = [
    { id: 1, value: "SIM" },
    { id: 2, value: "NÃO" },
    { id: 3, value: "Não se aplica (família sem criança/adolescente)" },
];

arrays["estadoCadastral"] = [
    { id: "0", value: "NENHUM" },
    { id: "1", value: "EM CADASTRAMENTO" },
    { id: "2", value: "SEM REGISTRO CIVIL" },
    { id: "3", value: "CADASTRADO" },
    { id: "4", value: "EXCLUÍDO" },
    { id: "5", value: "TRANSFERIDA" },
];


arrays["membros_na_familia"] = [
    { id: "1", value: "NÃO" },
    { id: "2", value: "SIM, COM CRIANÇAS DE 0 A 6 ANOS" },
    { id: "3", value: "SIM, COM CRIANÇAS E ADOLESCENTES DE 7 A 14 ANOS" },
    { id: "4", value: "SIM, COM ADOLESCENTES DE 15 A 17 ANOS" },
];

arrays["perfil_etario"] = [
    { id: "1", value: "Pessoas de 0 a 6 anos" },
    { id: "2", value: "Pessoas de 7 a 14 anos" },
    { id: "3", value: "Pessoas de 15 a 17 anos" },
    { id: "4", value: "Pessoas de 18 a 29 anos" },
    { id: "5", value: "Pessoas de 30 a 59 anos" },
    { id: "6", value: "Pessoas de 60 a 64 anos" },
    { id: "7", value: "Pessoas de 65 a 69 anos" },
    { id: "8", value: "Pessoas com 70 ou mais" },
];

arrays["perfil_etario_escolar"] = [
    {
        id: "1",
        value: "Pessoas entre 0 e 5 anos que não estão frequentando escola ou creche",
    },
    {
        id: "2",
        value: "Pessoas entre 06 e 14 anos que não estão frequentando escola",
    },
    {
        id: "3",
        value: "Pessoas entre 15 e 17 anos que não estão frequentando escola",
    },
    { id: "4", value: "Pessoas entre 10 e 17 anos que não sabem ler/escrever" },
    { id: "5", value: "Pessoas entre 18 e 59 anos que não sabem ler/escrever" },
    {
        id: "6",
        value: "Pessoas com 60 anos ou mais que não sabem ler/escrever",
    },
];

arrays["programas_prohab"] = [
    { id: "1", value: "Habitação de Interesse Social - HIS - FNHIS" },
    {
        id: "2",
        value: "Urbanização, Regularização e Integração de Assentamentos",
    },
    { id: "3", value: "Precários - UAP - FNHIS" },
    { id: "4", value: "Habitar Brasil BID - HBB" },
    { id: "5", value: "Pró - Moradia" },
    {
        id: "6",
        value: "Minha Casa Minha Vida - Municípios até 50 mil habitantes",
    },
    { id: "7", value: "Operações coletivas - FGTS" },
    { id: "8", value: "Minha Casa Minha Vida - FAR" },
    { id: "9", value: "Pró - Municípios" },
];
arrays["tipo_contato_telefone"] = [
    { id: "L", value: "CELULAR" },
    { id: "C", value: "TRABALHO" },
    { id: "R", value: "RESIDENCIAL" },
    { id: "O", value: "RECADO" },
    { id: "N", value: "NÃO TEM" },
    { id: "D", value: "NÃO DECLARADO" },
    { id: "S", value: "SEM COLETA DE DADOS" },
];

arrays["tipo_contato_email"] = [
    { id: "P", value: "PESSOAL" },
    { id: "R", value: "RECADO" },
    { id: "N", value: "NÃO TEM" },
    { id: "D", value: "NÃO DECLARADO" },
    { id: "S", value: "SEM COLETA DE DADOS" },
];
arrays["sexo_animal"] = [
    { id: "1", value: "MACHO" },
    { id: "2", value: "FÊMEA" },
];

arrays["especies_animais"] = [
    { id: "1", value: "CÃO" },
    { id: "2", value: "GATO" },
    { id: "3", value: "COELHO" },
    { id: "4", value: "HAMSTER" },
    { id: "5", value: "RATO" },
    { id: "6", value: "AVE" },
    { id: "7", value: "RÉPTIL" },
    { id: "8", value: "PEIXE" },
    { id: "9", value: "ANFÍBIO" },
    { id: "10", value: "INVERTEBRADO" },
    { id: "99", value: "OUTRO" },
];

arrays["local"] = [
    { id: 1, value: "Urbana" },
    { id: 2, value: "Rural" },
];

arrays["tipo_residencia"] = [
    { id: 1, value: "Particular Permanente - Própria" },
    { id: 2, value: "Particular improvisado - Própria improvisado" },
    { id: 3, value: "Coletivo" },
    { id: 4, value: "Alugada" },
    { id: 5, value: "Cedida" },
    { id: 6, value: "Ocupada" },
];

arrays["material_piso"] = [
    { id: 1, value: "Terra" },
    { id: 2, value: "Cimento" },
    { id: 3, value: "Madeira aproveitada" },
    { id: 4, value: "Madeira aparelhada" },
    { id: 5, value: "Cerâmica, lajota ou pedra" },
    { id: 6, value: "Carpete" },
    { id: 7, value: "Outro Material" },
];

arrays["material_paredes"] = [
    { id: 1, value: "Alvenaria/tijolo com revestimento" },
    { id: 2, value: "Alvenaria/tijolo sem revestimento" },
    { id: 3, value: "Madeira aparelhada" },
    { id: 4, value: "Taipa revestida" },
    { id: 5, value: "Taipa não revestida" },
    { id: 6, value: "Madeira aproveitada" },
    { id: 7, value: "Palha" },
    { id: 8, value: "Outro Material" },
];

arrays["forma_abastecimento_agua"] = [
    { id: 1, value: "Rede geral de distribuição" },
    { id: 2, value: "Poço ou nascente" },
    { id: 3, value: "Cisterna" },
    { id: 4, value: "Outra forma" },
];

arrays["forma_escoamento_sanitario"] = [
    { id: 1, value: "Rede coletora de esgoto ou pluvial" },
    { id: 2, value: "Fossa séptica" },
    { id: 3, value: "Fossa rudimentar" },
    { id: 4, value: "Vala a céu aberto" },
    { id: 5, value: "Direto para um rio, lago ou mar" },
    { id: 6, value: "Outra forma" },
];

arrays["destino_lixo"] = [
    { id: 1, value: "Coletado diretamente" },
    { id: 2, value: "Coletado indiretamente" },
    { id: 3, value: "Queimado ou enterrado na propriedade" },
    {
        id: 4,
        value: "Jogado em terreno baldio ou logradouro (rua, avenida etc.)",
    },
    { id: 5, value: "Jogado em rio ou mar" },
    { id: 6, value: "Tem outro destino" },
];

arrays["iluminacao"] = [
    { id: 1, value: "Elétrica com medidor próprio" },
    { id: 2, value: "Elétrica com medidor comunitário" },
    { id: 3, value: "Elétrica sem medidor" },
    { id: 4, value: "Óleo, querosene ou gás" },
    { id: 5, value: "Vela" },
    { id: 6, value: "Outra forma" },
    { id: 7, value: "Não possui energia elétrica no domicílio" },
];

arrays["calcamento_pavimentacao"] = [
    { id: 1, value: "Total" },
    { id: 2, value: "Parcial" },
    { id: 3, value: "Não existe" },
];

arrays["origem"] = [
    { id: 1, value: "CADASTRADO" },
    { id: 2, value: "IMPORTADO" },
];

arrays["posicao_familiar"] = [
    { id: 1, value: "RESPONSÁVEL FAMILIAR - RF" },
    { id: 2, value: "CÔNJUGE OU COMPANHEIRO(A)" },
    { id: 3, value: "FILHO(A)" },
    { id: 4, value: "ENTEADO(A)" },
    { id: 5, value: "NETO(A) OU BISNETO(A)" },
    { id: 6, value: "PAI OU MÃE" },
    { id: 7, value: "SOGRO(A)" },
    { id: 8, value: "IRMÃO OU IRMÃ" },
    { id: 9, value: "GENRO OU NORA" },
    { id: 10, value: "OUTRO PARENTE" },
    { id: 11, value: "NÃO PARENTE" },
];
arrays["posicao_familiar_s"] = [
    { id: "1", value: "RESPONSÁVEL FAMILIAR - RF" },
    { id: "2", value: "CÔNJUGE OU COMPANHEIRO(A)" },
    { id: "3", value: "FILHO(A)" },
    { id: "4", value: "ENTEADO(A)" },
    { id: "5", value: "NETO(A) OU BISNETO(A)" },
    { id: "6", value: "PAI OU MÃE" },
    { id: "7", value: "SOGRO(A)" },
    { id: "8", value: "IRMÃO OU IRMÃ" },
    { id: "9", value: "GENRO OU NORA" },
    { id: "10", value: "OUTRO PARENTE" },
    { id: "11", value: "NÃO PARENTE" },
];
arrays["posicao_familiar_sr"] = [
    { id: 1, value: "RESPONSÁVEL FAMILIAR - RF" },
    { id: 2, value: "CÔNJUGE OU COMPANHEIRO(A)" },
    { id: 3, value: "FILHO(A)" },
    { id: 4, value: "ENTEADO(A)" },
    { id: 5, value: "NETO(A) OU BISNETO(A)" },
    { id: 6, value: "PAI OU MÃE" },
    { id: 7, value: "SOGRO(A)" },
    { id: 8, value: "IRMÃO OU IRMÃ" },
    { id: 9, value: "GENRO OU NORA" },
    { id: 10, value: "OUTRO PARENTE" },
    { id: 11, value: "NÃO PARENTE" },
];
arrays["posicao_familiar_sr_s"] = [
    { id: "1", value: "RESPONSÁVEL FAMILIAR - RF" },
    { id: "2", value: "CÔNJUGE OU COMPANHEIRO(A)" },
    { id: "3", value: "FILHO(A)" },
    { id: "4", value: "ENTEADO(A)" },
    { id: "5", value: "NETO(A) OU BISNETO(A)" },
    { id: "6", value: "PAI OU MÃE" },
    { id: "7", value: "SOGRO(A)" },
    { id: "8", value: "IRMÃO OU IRMÃ" },
    { id: "9", value: "GENRO OU NORA" },
    { id: "10", value: "OUTRO PARENTE" },
    { id: "11", value: "NÃO PARENTE" },
];

arrays["estado_civil"] = [
    { id: 1, value: "SOLTEIRO(A)" },
    { id: 2, value: "CASADO(A)" },
    { id: 3, value: "SEPARADO(A)" },
    { id: 4, value: "DIVORCIADO(A)" },
    { id: 5, value: "VIÚVO(A)" },
    { id: 6, value: "UNIÃO ESTÁVEL" },
];
arrays["motivo_exclusao"] = [
    { id: 1, value: "FALECIMENTO DA PESSOA" },
    { id: 2, value: "DESLIGAMENTO DA PESSOA DAQUELA FAMÍLIA" },
    { id: 3, value: "SOLICITAÇÃO DA PESSOA" },
    { id: 4, value: "DECISÃO JUDICIAL" },
    { id: 5, value: 'DECURSO DE PRAZO NO ESTADO CADASTRAL "EM CADASTRAMENTO"' },
    { id: 6, value: "MUDANÇA DE ENDEREÇO OCORRIDO ANTERIORMENTE A V7" },
    { id: 7, value: "CADASTRAMENTO INCORRETO OCORRIDO ANTERIORMENTE A V7" },
    { id: 8, value: "PESSOA TRANSFERIDA" },
    { id: 9, value: "CADASTRO DESATUALIZADO HÁ MAIS DE 48 MESES" },
    { id: 10, value: "MULTIPLICIDADE" },
    { id: 11, value: "AVERIGUAÇÃO CADASTRAL" },
    { id: 99, value: "EXCLUSÃO DA FAMÍLIA" },
];

arrays["estado_cadastral"] = [
    { id: 1, value: "EM CADASTRAMENTO" },
    { id: 2, value: "SEM REGISTRO CIVIL" },
    { id: 3, value: "CADASTRADO" },
    { id: 4, value: "EXCLUÍDO" },
    { id: 5, value: "AGUARDANDO NIS" },
    { id: 6, value: "VALIDANDO NIS" },
    { id: 7, value: "TRANSFERIDO" },
    { id: 99, value: "INSERIDO MANUALMENTE" },
];
(arrays["estado_cadastral_familia"] = [
    { id: 0, value: "NENHUM" },
    { id: 1, value: "EM CADASTRAMENTO" },
    { id: 2, value: "SEM REGISTRO CIVIL" },
    { id: 3, value: "CADASTRADO" },
    { id: 4, value: "EXCLUÍDO" },
    { id: 5, value: "TRANSFERIDA" },
    { id: 6, value: "DESLIGADA" },
    { id: 7, value: "INATIVA" },
    { id: 8, value: "ATIVA" },
    { id: 99, value: "SEM DADOS CADASTRAIS" },
]),
    (arrays["estado_cadastral_familia_filtros"] = [
        { id: "NENHUM", value: "INSERIDO MANUALMENTE" },
        { id: 1, value: "EM CADASTRAMENTO" },
        { id: 2, value: "SEM REGISTRO CIVIL" },
        { id: 3, value: "CADASTRADO" },
        { id: 4, value: "EXCLUÍDO" },
        { id: 5, value: "TRANSFERIDA" },
        { id: 99, value: "SEM DADOS CADASTRAIS" },
    ]),
    (arrays["registro_cartorio"] = [
        { id: "1", value: "SIM E TEM CERTIDÃO DE NASCIMENTO" },
        { id: "2", value: "SIM, MAS NÃO TEM CERTIDÃO DE NASCIMENTO" },
        { id: "3", value: "NÃO" },
        { id: "4", value: "NÃO SABE" },
    ]);

arrays["providenciar_documentacao"] = [
    { id: 1, value: "CERTIDÃO DE NASCIMENTO" },
    { id: 2, value: "CARTEIRA DE IDENTIDADE" },
    { id: 3, value: "CARTEIRA DE TRABALHO E PREVIDÊNCIA SOCIAL" },
    { id: 4, value: "CADASTRO DE PESSOA FÍSICA" },
    { id: 5, value: "TÍTULO DE ELEITOR" },
];

arrays["tipo_certidao"] = [
    { id: "1", value: "NASCIMENTO" },
    { id: "2", value: "CASAMENTO" },
    { id: "3", value: "INDÍGENA RANI" },
    { id: "4", value: "ÓBITO" },
];

arrays["frequenta_escola"] = [
    { id: "1", value: "SIM, REDE PÚBLICA" },
    { id: "2", value: "SIM, REDE PARTICULAR" },
    { id: "3", value: "NÃO, JÁ FREQUENTOU" },
    { id: "4", value: "NUNCA FREQUENTOU" },
];

arrays["curso_frequenta"] = [
    { id: "1", value: "CRECHE" },
    { id: "2", value: "PRÉ_ESCOLA (EXCETO CA)" },
    { id: "3", value: "CLASSE DE ALFABETIZAÇÃO - CA" },
    { id: "4", value: "ENSINO FUNDAMENTAL REGULAR (DURAÇÃO 8 ANOS)" },
    { id: "5", value: "ENSINO FUNDAMENTAL REGULAR (DURAÇÃO 9 ANOS)" },
    { id: "6", value: "ENSINO FUNDAMENTAL ESPECIAL" },
    { id: "7", value: "ENSINO MÉDIO REGULAR" },
    { id: "8", value: "ENSINO MÉDIO ESPECIAL" },
    {
        id: "9",
        value: "ENSINO FUNDAMENTAL EJA-SÉRIES INICIAIS (SUPLETIVO - 1ª A 4ª)",
    },
    {
        id: "10",
        value: "ENSINO FUNDAMENTAL EJA-SÉRIES FINAIS (SUPLETIVO - 5ª A 8ª)",
    },
    { id: "11", value: "ENSINO MÉDIO EJA (SUPLETIVO)" },
    { id: "12", value: "ALFABETIZAÇÃO PARA ADULTOS (MOBRAL etc.)" },
    {
        id: "13",
        value: "SUPERIOR, APERFEIÇOAMENTO, ESPECIALIZAÇÃO, MESTRADO, DOUTORADO",
    },
    { id: "14", value: "PRÉ-VESTIBULAR" },
];

arrays["curso_frequentou"] = [
    { id: "1", value: "CRECHE" },
    { id: "2", value: "PRÉ_ESCOLA (EXCETO CA)" },
    { id: "3", value: "CLASSE DE ALFABETIZAÇÃO - CA" },
    {
        id: "4",
        value: "ENSINO FUNDAMENTAL 1ª A 4ª SÉRIES, ELEMENTAR (PRIMÁRIO), PRIMEIRA FASE DO 1º GRAU",
    },
    {
        id: "5",
        value: "ENSINO FUNDAMENTAL 5ª A 8ª SÉRIES, MÉDIO 1º CICLO (GINASIAL), SEGUNDA FASE DO 1º GRAU",
    },
    { id: "6", value: "ENSINO FUNDAMENTAL (DURAÇÃO 9 ANOS)" },
    { id: "7", value: "ENSINO FUNDAMENTAL ESPECIAL" },
    {
        id: "8",
        value: "ENSINO MÉDIO, 2º GRAU, MÉDIO 2º CICLO (CIENTÍFICO, CLÁSSICO, TÉCNICO, NORMAL)",
    },
    { id: "9", value: "ENSINO MÉDIO ESPECIAL" },
    {
        id: "10",
        value: "ENSINO FUNDAMENTAL EJA-SÉRIES INICIAIS (SUPLETIVO 1ª A 4ª)",
    },
    {
        id: "11",
        value: "ENSINO FUNDAMENTAL EJA-SÉRIES FINAIS (SUPLETIVO 5ª A 8ª)",
    },
    { id: "12", value: "ENSINO MÉDIO EJA (SUPLETIVO)" },
    {
        id: "13",
        value: "SUPERIOR, APERFEIÇOAMENTO, ESPECIALIZAÇÃO, MESTRADO, DOUTORADO",
    },
    { id: "14", value: "ALFABETIZAÇÃO PARA ADULTOS (MOBRAL etc.)" },
    { id: "15", value: "NENHUM" },
];

arrays["ano_serie"] = [
    { id: "1", value: "PRIMEIRO(A)" },
    { id: "2", value: "SEGUNDO(A)" },
    { id: "3", value: "TERCEIRO(A)" },
    { id: "4", value: "QUARTO(A)" },
    { id: "5", value: "QUINTO(A)" },
    { id: "6", value: "SEXTO(A)" },
    { id: "7", value: "SÉTIMO(A)" },
    { id: "8", value: "OITAVO(A)" },
    { id: "9", value: "NONO(A)" },
    { id: "10", value: "CURSO NÃO-SERIADO" },
];

arrays["situacao_cadastral"] = [
    { id: 1, value: "EM CADASTRAMENTO" },
    { id: 2, value: "SEM REGISTRO CIVIL" },
    { id: 3, value: "CADASTRADO" },
    { id: 4, value: "EXCLUIDO" },
    { id: 5, value: "AGUARDANDO ATRIBUIÇÃO NIS" },
    { id: 6, value: "AGUARDANDO ALTERAÇÃO DE CARACTERIZAÇÃO" },
];

arrays["cuidado_permanentes"] = [
    { id: 1, value: "NÃO" },
    { id: 2, value: "SIM, DE ALGUÉM DA FAMÍLIA" },
    { id: 3, value: "SIM, DE CUIDADOR ESPECIALIZADO" },
    { id: 4, value: "SIM, DE VIZINHO" },
    { id: 5, value: "SIM, DE INSTITUIÇÃO DA REDE SOCIOASSISTENCIAL" },
    { id: 6, value: "SIM, DE OUTRA FORMA" },
];

arrays["periodo"] = [
    { id: 1, value: "DIA(S)" },
    { id: 2, value: "MÊS(ES)" },
    { id: 3, value: "ANO(S)" },
];
arrays["periodo_enum"] = [
    { id: "1", value: "DIA(S)" },
    { id: "2", value: "MÊS(ES)" },
    { id: "3", value: "ANO(S)" },
];

arrays["conta_tipo"] = [
    { id: 1, value: "CORRENTE" },
    { id: 2, value: "POUPANÇA" },
];

arrays["status_situacao_rua"] = [
    { id: "1", value: "ATIVO" },
    { id: "2", value: "INATIVO" },
    { id: "3", value: "ÓBITO" },
    { id: "4", value: "RECAMBIO" },
    { id: "5", value: "ILPI" },
    { id: "6", value: "AUTONOMIA" },
    { id: "7", value: "RETORNO FAMILIAR" },
];

arrays["cod_tempo"] = [
    { id: "1", value: "Até seis meses" },
    { id: "2", value: "Entre seis meses e um ano" },
    { id: "3", value: "Entre um e dois anos" },
    { id: "4", value: "Entre dois e cinco anos" },
    { id: "5", value: "Entre cinco e dez anos" },
    { id: "6", value: "Mais de dez anos" },
];

arrays["cod_tempo_contato"] = [
    { id: "1", value: "Todo dia" },
    { id: "2", value: "Toda semana" },
    { id: "3", value: "Todo mês" },
    { id: "4", value: "Todo Ano" },
    { id: "5", value: "Quase nunca" },
    { id: "6", value: "Nunca" },
];

arrays["beneficios"] = [
    { id: "1", value: "AUXÍLIO-DOENÇA" },
    { id: "2", value: "AUXÍLIO-ACIDENTE" },
    { id: "3", value: "AUXÍLIO-RECLUSÃO" },
    { id: "4", value: "PENSÃO POR MORTE" },
    { id: "5", value: "SALÁRIO-FAMÍLIA" },
    { id: "6", value: "SALÁRIO-MATERNIDADE" },
    { id: "7", value: "BENEFÍCIO DE PRESTAÇÃO CONTINUADA - PESSOA IDOSA" },
    {
        id: "8",
        value: "BENEFÍCIO DE PRESTAÇÃO CONTINUADA - PESSOA COM DEFICIÊNCIA",
    },
];

arrays["programa_social_acolhimento"] = [
    { id: "1", value: "PROGRAMA BOLSA FAMÍLIA" },
    { id: "2", value: "FRENTE DE TRABALHO" },
    { id: "3", value: "PROGRAMA DE ERRADICAÇÃO DO TRABALHO INFANTIL" },
    { id: "4", value: "BENEFÍCIO DE PRESTAÇÃO CONTINUADA (BPC) PESSOA IDOSA" },
    { id: "5", value: "BENEFÍCIO DE PRESTAÇÃO CONTINUADA (BPC) PESSOA COM DEFICIÊNCIA" },
    { id: "6", value: "OUTRO" },
];

arrays["aposentadoria_motivo"] = [
    { id: "1", value: "POR IDADE" },
    { id: "2", value: "POR IDADE DA PESSOA COM DEFICIÊNCIA" },
    { id: "3", value: "POR TEMPO DE CONTRIBUIÇÃO" },
    { id: "4", value: "POR TEMPO DE CONTRIBUIÇÃO DA PESSOA COM DEFICIÊNCIA" },
    { id: "5", value: "POR TEMPO DE CONTRIBUIÇÃO DO PROFESSOR" },
    { id: "6", value: "POR INVALIDEZ" },
    { id: "7", value: "ESPECIAL POR TEMPO DE CONTRIBUIÇÃO" },
];

arrays["profissao_principal"] = [
    { id: "1", value: "TRABALHADOR POR CONTA PRÓPRIA (BICO, AUTÔNOMO)" },
    { id: "2", value: "TRABALHADOR TEMPORÁRIO EM ÁREA RURAL" },
    { id: "3", value: "EMPREGADO SEM CARTEIRA DE TRABALHO ASSINADA" },
    { id: "4", value: "EMPREGADO COM CARTEIRA DE TRABALHO ASSINADA" },
    {
        id: "5",
        value: "TRABALHADOR DOMÉSTICO SEM CARTEIRA DE TRABALHO ASSINADA",
    },
    {
        id: "6",
        value: "TRABALHADOR DOMÉSTICO COM CARTEIRA DE TRABALHO ASSINADA",
    },
    { id: "7", value: "TRABALHADOR NÃO-REMUNERADO" },
    { id: "8", value: "MILITAR OU SERVIDOR PÚBLICO" },
    { id: "9", value: "EMPREGADOR" },
    { id: "10", value: "ESTAGIÁRIO" },
    { id: "11", value: "APRENDIZ" },
];
arrays["pendencias_familia"] = [
    {
        id: "desativacao_comu_quilombola",
        value: `Existência de pendência "Desativação de Comunidades Quilombolas" para a família.`,
    },

    {
        id: "desativacao_terras_indigenas",
        value: `Existência de pendência "Desativação de Terras Indígenas" para a família.`,
    },

    {
        id: "desativacao_cras_creas",
        value: `Existência de pendência "Desativação de CRAS E CREAS" para a família.`,
    },

    {
        id: "desativacao_eas",
        value: `Existência de pendência "Desativação de EAS" para a família.`,
    },

    {
        id: "camp_em_branco_principal",
        value: `Existência de pendência "Campos Obrigatórios ou Obrigatórios Condicionados Não Preenchidos do formulário principal" para a família.`,
    },

    {
        id: "camp_em_branco_sup_um",
        value: `Existência de pendência "Campos Obrigatórios ou Obrigatórios Condicionados Não Preenchidos do formulário suplementar 1" para a família.`,
    },

    {
        id: "camp_sem_rf",
        value: `Existência de pendência "Família sem Responsável Familiar cadastrado" para a família.`,
    },


    {
        id: "fam_destalizada_dois_anos",
        value: `Existência de pendência "Famílias com dados desatualizados há mais de 24 meses (Família que não sofreu nenhuma atualização nos campos sensíveis há mais de 24 meses.)" para a família.`,
    },

    {
        id: "fam_transfer{ida_munic",
        value: `Existência de Ocorrência "Família transferida para outro município" para a família.`,
    },

    {
        id: "fam_transfer{ida_nova_munic",
        value: `Existência de Ocorrência "Família transferida para este município em uma nova família" para a família.`,
    },

    {
        id: "fam_transfer{ida_exist_munic",
        value: `Existência de Ocorrência "Família transferida para este município em família existente" para a família.`,
    },

    {
        id: "fam_transfer{ida_outra_munic",
        value: `Existência de Ocorrência "Família transferida para outra família no mesmo município" para a família.`,
    },

    {
        id: "fam_sem_un{idade_territorial",
        value: `Existência de Ocorrência "Família sem unidade territorial local (pendência somente para prefeituras que optarem por utilizar esse campo); " para a família.`,
    },

];
arrays["pendencias_usuarios"] = [
    {
        id: "ind_ptab_desat_inep_memb",
        value: 'Existência de pendência "Desativação de INEP"  para a pessoa',
    },
    {
        id: "ind_pmig_cpo_obr_memb",
        value: 'Existência de pendência " Campos Obrigatórios ou Obrigatórios Condicionados Não Preenchidos"  para a pessoa',
    },
    {
        id: "ind_pmig_sem_doc_memb",
        value: 'Existência de pendência "Membro da família sem NENHUMA documentação (exceto o caso da pessoa SEM registro civil conforme RN019)"  para a pessoa',
    },
    {
        id: "ind_pmig_rf_cpf_eleitor_memb",
        value: 'Existência de pendência "Responsável Familiar sem CPF ou Título de Eleitor;"  para a pessoa:',
    },
    {
        id: "ind_pmig_rf_cpf_inv_memb",
        value: 'Existência de pendência " Responsável Familiar com CPF inválido (DV inválido)"  para a pessoa:',
    },
    {
        id: "ind_pmig_rf_cpf_mult_memb",
        value: 'Existência de pendência "Responsável Familiar com CPF em multiplicidade"  para a pessoa:',
    },
    {
        id: "ind_pmig_memb_cpf_mult_memb",
        value: 'Existência de pendência "Membro com CPF em multiplicidade"  para a pessoa:',
    },
    {
        id: "ind_pmig_rf_cpf_titular_memb",
        value: 'Existência de pendência " Responsável Familiar com divergência de titularidade de CPF (validação de titularidade com base na receita federal)"  para a pessoa:',
    },
    {
        id: "ind_pmig_memb_cpf_titular_memb",
        value: 'Existência de pendência " Membro com divergência de titularidade de CPF (validação de titularidade com base na receita federal)"  para a pessoa:',
    },
    {
        id: "ind_pmig_rf_eleitor_inv_memb",
        value: 'Existência de pendência "Responsável Familiar com Título de Eleitor inválido (DV inválido)"  para a pessoa:',
    },
    {
        id: "ind_pmig_rf_eleitor_mult_memb",
        value: 'Existência de pendência " Responsável Familiar com Título de Eleitor  em multiplicidade"  para a pessoa:',
    },
    {
        id: "ind_pmig_memb_cpf_inv_memb",
        value: 'Existência de pendência "Membro com CPF inválido (DV inválido)"  para a pessoa:',
    },
    {
        id: "ind_pmig_memb_eleitor_mult_memb",
        value: 'Existência de pendência "Membro com Título de Eleitor em multiplicidade"  para a pessoa:',
    },
    {
        id: "ind_pmig_rf_idade_16_memb",
        value: 'Existência de pendência "Responsável Familiar com idade inferior a 16 anos"  para a pessoa:',
    },
    {
        id: "ind_ptrn_memb_inep_memb",
        value: 'Existência de pendência "Verificação dos dados da escola (INEP)"  para a pessoa:',
    },
    {
        id: "ind_ptrn_memb_parente_memb",
        value: 'Existência de pendência "pessoa sem relação de parentesco"  para a pessoa',
    },
    {
        id: "ind_paud_cpo_obr_memb",
        value: 'Existência de pendência " campos obrigatórios ou obrigatórios condicionados não preenchidos"  para a pessoa:',
    },
    {
        id: "ind_paud_rf_cpf_eleitor_memb",
        value: 'Existência de pendência "responsável familiar sem cpf ou título de eleitor;"  para a pessoa:',
    },
    {
        id: "ind_paud_rf_cpf_inv_memb",
        value: 'Existência de pendência "responsável familiar com cpf inválido (dv inválido)"  para a pessoa:',
    },
    {
        id: "ind_paud_rf_cpf_mult_memb",
        value: 'Existência de pendência "responsável familiar com cpf em multiplicidade"  para a pessoa:',
    },
    {
        id: "ind_paud_memb_cpf_mult_memb",
        value: 'Existência de pendência "membro com cpf em multiplicidade"  para a pessoa:',
    },
    {
        id: "ind_paud_rf_cpf_titular_memb",
        value: 'Existência de pendência "responsável familiar com divergência de titularidade de cpf (validação de titularidade com base na receita federal)"  para a pessoa:',
    },
    {
        id: "ind_paud_memb_cpf_titular_memb",
        value: 'Existência de pendência "membro com divergência de titularidade de cpf (validação de titularidade com base na receita federal)"  para a pessoa:',
    },
    {
        id: "ind_paud_memb_cpf_inv_memb",
        value: 'Existência de pendência "membro com cpf inválido (dv inválido)"  para a pessoa:',
    },
    {
        id: "ind_paud_memb_eleitor_inv_memb",
        value: 'Existência de pendência "membro com título de eleitor inválido (dv inválido)"  para a pessoa:',
    },
    {
        id: "ind_paud_rf_eleitor_inv_memb",
        value: 'Existência de pendência "responsável familiar com título de eleitor inválido (dv inválido)"  para a pessoa:',
    },
    {
        id: "ind_paud_memb_eleitor_mult_memb",
        value: 'Existência de pendência "membro com título de eleitor em multiplicidade"  para a pessoa:',
    },
    {
        id: "ind_paud_rf_idade_16_memb",
        value: 'Existência de pendência "responsável familiar com idade inferior a 16 anos"  para a pessoa:',
    },
    {
        id: "ind_paud_rejei_memb",
        value: ' Existência de pendência "Rejeição de inclusão/atualização dos dados cadastrais da pessoa"  para a pessoa:',
    },
    {
        id: "ind_otrn_outro_mun_pes",
        value: 'Existência de ocorrência  " pessoa  transferida para outro município"  para a pessoa:',
    },
    {
        id: "ind_otrn_nova_pes",
        value: ' Existência de ocorrência  " pessoa de outro município (origem) transferida para este município (destino ) em uma nova família; (destino)"  para a pessoa:',
    },
    {
        id: "ind_otrn_exist_pes",
        value: 'Existência de ocorrência  " pessoa de outro município (origem) transferida para este município (destino )em família existente"  para a pessoa:	',
    },
    {
        id: "ind_otrn_outra_pes",
        value: 'Existência de ocorrência  "pessoa transferida para outra família no mesmo município"  para a pessoa:',
    },
    {
        id: "ind_osrg_sem_certidao_pes",
        value: 'Existência de ocorrência  "registrada e sem certidão civil (conforme RN019)"  para a pessoa:',
    },
    {
        id: "ind_osrg_sem_registro_pes",
        value: 'Existência de ocorrência  "não registrada em cartório (conforme RN019)"  para a pessoa:',
    },
    {
        id: "ind_osrg_nao_sabe_pes",
        value: ' Existência de ocorrência  "não sabe se foi registrada em cartório (conforme RN019)"  para a pessoa:',
    },
    {
        id: "ind_paud_mbo_cad_com_cert_obit",
        value: 'Existência de pendência "membro da família cadastrado e com certidão de óbito"  para a pessoa:',
    },
];

arrays["efeito_descumprimento"] = [
    { id: 1, value: "Advertência" },
    { id: 2, value: "Bloqueio" },
    { id: 3, value: "Suspensão" },
    { id: 4, value: "Cancelamento" },
];

arrays["beneficiario_sesan"] = [
    { id: "vende_leite", value: "Vende leite para o programa do leite." },
    { id: "receb_leite", value: "Recebe leite do programa do leite." },
    {
        id: "vende_alim_paa",
        value: "Vende alimentos para o PAA - Compra Direta.",
    },
    { id: "receb_alim_paa", value: "Recebe alimentos do PAA - Compra Direta." },
    { id: "receb_cesta_basica", value: "Recebe cesta de alimentos." },
    {
        id: "refei_restau_popular",
        value: "Faz refeição em restaurante popular.",
    },
    { id: "refei_cozinha_comum", value: "Faz refeição em cozinha comunitária." },
    {
        id: "partic_alim_nutricao",
        value: "Participou de curso em alimentação e nutrição.",
    },
    {
        id: "capit_agua_chuva_prod_alim",
        value: "Recebeu infraestrutura de captação de água da chuva para produzir alimentos.",
    },
    {
        id: "receb_cisterna",
        value: "Recebeu cisterna para armazenamento de água da chuva.",
    },
    {
        id: "horta_comunitaria",
        value: "Participa de projetos de produção de alimentos (horta comunitária, criação de pequenos animais, viveiros e pomares).",
    },
    {
        id: "proj_cart_indigena",
        value: "Participa de projeto da Carteira Indígena (Parceria MMA/MDS).",
    },
    {
        id: "feira_pop_mds",
        value: "Vende alimentos em feira livre popular financiada pelo MDS.",
    },
    { id: "sesan_nenhum", value: "Nenhum" },
];

arrays["beneficiario_ministerio_minas_energia"] = [
    {
        id: "min_energ_tarifa_soc",
        value: "Recebe sua conta de energia elétrica faturada como Tarifa Social.",
    },
    {
        id: "min_energ_elet_doacao",
        value: "Recebeu de sua distribuidora de energia elétrica doação de lâmpadas ou outros equipamentos para reduzir o consumo de energia.",
    },
    {
        id: "min_energ_luz_n_pagou",
        value: "Não pagou pela instalação de energia na entrada de sua residência.",
    },
    { id: "min_energ_nenhum", value: "Nenhum" },
];

arrays["atendido_programa_assistencia_social"] = [
    {
        id: "snas_bpc_deficiente",
        value: "Benefício de Prestação Continuada - BPC deficiente.",
    },
    {
        id: "snas_bpc_idoso",
        value: "Benefício de Prestação Continuada - BPC pessoa idosa.",
    },
    { id: "snas_paif", value: "Programa de Atenção Integral à Família - PAIF." },
    {
        id: "snas_crianca_0_6_anos",
        value: "Crianças de 0 a 6 anos em ações socioeducativas de apoio à família.",
    },
    {
        id: "snas_grupos_idosos",
        value: "Centros e Grupos de convivência para pessoas idosas.",
    },
    {
        id: "snas_abrigo_mulher_vitima",
        value: "Abrigo para mulheres vítimas de violência.",
    },
    {
        id: "snas_abrigo_crianca_adoles",
        value: "Abrigo para crianças e adolescentes.",
    },
    { id: "snas_abrigo_idosos", value: "Abrigo para pessoas idosas." },
    {
        id: "snas_abrigo_adultos",
        value: "Abrigo/albergue para adultos e famílias.",
    },
    {
        id: "snas_abrigo_popul_adulta",
        value: "Abrigo/albergue para população adulta em situação de rua.",
    },
    { id: "snas_projovem_adolescente", value: "ProJovem Adolescente." },
    { id: "snas_projovem_urbano", value: "ProJovem Urbano." },
    { id: "snas_projovem_campo", value: "ProJovem Campo." },
    { id: "snas_projovem_trabalhador", value: "ProJovem Trabalhador." },
    {
        id: "snas_habilit_reabilit_deficiencia",
        value: "Serviço de referência e apoio à habilitação e reabilitação de pessoas com deficiência.",
    },
    {
        id: "snas_enfrenta_violencia_crianca",
        value: "Serviço de enfrentamento à violência, abuso e exploração sexual contra crianças, adolescentes e suas famílias.",
    },
    {
        id: "snas_acomp_social_liberdade",
        value: "Serviço de acompanhamento social a adolescentes em medida socioeducativa de liberdade assistida.",
    },
    {
        id: "snas_acomp_social_liberdade_comunidade",
        value: "Serviço de acompanhamento social a adolescentes em medida socioeducativa de prestação de serviços à comunidade.",
    },
    {
        id: "snas_orientacao_especial_criancas_adol",
        value: "Serviço de orientação e apoio especializado a crianças, adolescentes e famílias.",
    },
    {
        id: "snas_centro_dia_idoso",
        value: "Serviço de Centro-Dia (atendimento à pessoa idosa com deficiência).",
    },
    {
        id: "snas_atend_domic_idosos_defic",
        value: "Serviço de atendimento no domicílio de pessoas idosas e pessoas com deficiência.",
    },
    { id: "snas_inclusao_produtiva", value: "Projetos de inclusão produtiva." },
    {
        id: "snas_peti",
        value: "Programa de Erradicação do Trabalho Infantil - PETI.",
    },
    { id: "snas_nenhum", value: "Nenhum." },
];

arrays["parc_mds"] = [
    { id: "101", value: "Família Cigana" },
    { id: "201", value: "Família Extrativista" },
    { id: "202", value: "Família de Pescadores Artesanais" },
    { id: "203", value: "Família pertecente a comunidade de terreiro" },
    { id: "204", value: "Família Ribeirinha" },
    { id: "205", value: "Família de agricultores familiares" },
    { id: "301", value: "Família assentada da reforma agrária" },
    {
        id: "302",
        value: "Família que não recebe o benefício do programa nacional de crédito fundiário",
    },
    { id: "303", value: "Família acampada" },
    {
        id: "304",
        value: "Família atingida por empreendimentos de infraestrutura",
    },
    { id: "305", value: "Família de preso do sistema carcerário" },
    { id: "306", value: "Família de catadores de material reciclável" },
    { id: "401", value: "Desalojados/Desabrigados" },
    { id: "000", value: "Nenhuma" },
];

arrays["relacoes_conjugais_familia"] = [
    { id: 1, value: "Conflituoso, com violência" },
    { id: 2, value: "Conflituoso, sem violência" },
    { id: 3, value: "Sem conflitos relevantes" },
];
arrays["relacoes_conflituosas_outros"] = [
    {
        id: 1,
        value: "Sim, com presença de violência. Caso sim, utilize a página ao lado para anotar as informações relevantes",
    },
    {
        id: 2,
        value: "Sim, sem presença de violência. Caso sim, utilize a página ao lado para anotar as informações relevantes",
    },
    {
        id: 3,
        value: "Não há conflitos relevantes envolvendo outros indivíduos que residam no domicílio",
    },
];

arrays["atendimento_status"] = [
    { id: "1", value: "Aberto" },
    { id: "2", value: "Acompanhamento" },
    { id: "3", value: "Inativo" },
    { id: "4", value: "Encaminhado para Benefício" },
    { id: "5", value: "Falecido(a)" },
    { id: "6", value: "Finalizado" },
    { id: "7", value: "Recambio" },
    { id: "8", value: "ILPI" },
    { id: "9", value: "Autonomia" },
    { id: "10", value: "Retorno Familiar" },
];

arrays["encaminhamento_status"] = [
    { id: "1", value: "Encaminhado" },
    { id: "2", value: "Resposta do Destinatário" },
    { id: "3", value: "Resposta do Emissário" },
    { id: "4", value: "Vencido" },
    { id: "5", value: "Cancelado" },
    { id: "6", value: "Finalizado" },
];

arrays["denuncia_status"] = [
    { id: "1", value: "Aberto" },
    { id: "2", value: "Visita" },
    { id: "3", value: "Trote" },
    { id: "4", value: "Falsa" },
    { id: "5", value: "Encaminhada" },
];

arrays["denunciate"] = [
    { id: 1, value: "Escola" },
    { id: 2, value: "Hospital" },
    { id: 3, value: "Polícia" },
    { id: 4, value: "Vizinhos" },
    { id: 5, value: "Anônimo" },
    { id: 6, value: "Identificado" },
];

arrays["canal_denuncia"] = [
    { id: 1, value: "Correspondência" },
    { id: 2, value: "Disque 100" },
    { id: 11, value: "Disque 156" },
    { id: 3, value: "Disque 180" },
    { id: 4, value: "E-mail" },
    { id: 5, value: "Telefone/Fax" },
    { id: 6, value: "Conselheiro" },
    { id: 7, value: "Ofício" },
    { id: 8, value: "Presencial" },
    { id: 9, value: "Serviços da Web" },
    { id: 10, value: "Outros documentos físicos" },
];

/*
Status de Atividades
*/
arrays["atividade_status"] = [
    { id: "1", value: "ABERTO" },
    { id: "2", value: "EM ANDAMENTO" },
    { id: "3", value: "REALIZADO" },
    { id: "4", value: "CANCELADO" },
    { id: "5", value: "EXCLUÍDO" },
];

arrays["status_oficio"] = [
    { id: 1, value: "ABERTO" },
    { id: 2, value: "ENVIADO" },
    { id: 3, value: "RESPONDIDO" },
    { id: 4, value: "FINALIZADO" },
    { id: 5, value: "EXCLUÍDO" },
];

arrays["situacao_abordagem_social"] = [
    {
        id: 1,
        value: "Crianças ou adolescentes em situação de trabalho infantil (até 15 anos)",
    },
    {
        id: 2,
        value: "Crianças ou adolescentes em situação de exploração sexual",
    },
    { id: 7, value: "Criança ou adolescente em situação de rua" },
    {
        id: 3,
        value: "Crianças ou adolescentes usuárias de crack ou outras drogas ilícitas",
    },
    {
        id: 4,
        value: "Pessoas adultas usuárias de crack ou outras drogas ilícitas",
    },
    { id: 8, value: "Pessoas adultas em situação de rua" },
    { id: 5, value: "Migrantes" },
    { id: 6, value: "Outros" },
];

arrays["atendimento_local"] = [
    { id: 1, value: "Domicílio" },
    { id: 2, value: "Unidade" },
    { id: 3, value: "Espaço Público" },
    { id: 4, value: "Outra Unidade" },
];

arrays["tiposEscolaridadeTecnicos"] = [
    { id: 1, value: "Ensino Fundamental Incompleto" },
    { id: 2, value: "Ensino Fundamental Completo" },
    { id: 3, value: "Ensino Médio Incompleto" },
    { id: 4, value: "Ensino Médio Completo" },
    { id: 5, value: "Ensino Superior Incompleto" },
    { id: 6, value: "Ensino Superior Completo" },
    { id: 7, value: "Especialização" },
    { id: 8, value: "Mestrado" },
    { id: 9, value: "Doutorado" },
];
arrays["regimeTrabalhoTecnicos"] = [
    { id: 1, value: "Comissionado" },
    { id: 2, value: "Empregado Público (CLT)" },
    { id: 3, value: "Outro vínculo não permanente" },
    { id: 4, value: "Servidor Temporário" },
    { id: 5, value: "Servidor Estatutário" },
    { id: 6, value: "Terceirizado" },
    { id: 7, value: "Entidade Prestadora de Serviços" },
    { id: 8, value: "Voluntário" },
];
arrays["cargaHorariaTecnicos"] = [
    { id: 1, value: "Menor que 20 horas semanais" },
    { id: 2, value: "20 horas semanais" },
    { id: 3, value: "30 horas semanais" },
    { id: 4, value: "40 horas semanais" },
    { id: 5, value: "Maior que 40 horas semanais" },
];

arrays["motivo_desligamento"] = [
    { id: 1, value: "Superação das vulnerabilidades" },
    { id: 2, value: "Evasão ou recusa da família" },
    { id: 3, value: "Mudança de município" },
    { id: 4, value: "Outros" },
];

arrays["acompanhamento_periodicidade"] = [
    { id: 1, value: "Semanal" },
    { id: 2, value: "Quinzenal" },
    { id: 3, value: "Mensal" },
];

arrays["avaliacao_vinculo"] = [
    { id: 1, value: "Bom" },
    { id: 2, value: "Fragilizados" },
    { id: 3, value: "Conflituoso, sem violência" },
    { id: 4, value: "Conflituoso, com violência" },
    { id: 5, value: "Rompidos" },
];

arrays["tempo_na_rua"] = [
    { id: 1, value: "Maior parte do dia" },
    { id: 2, value: "Meio período" },
    { id: 3, value: "Raramente" },
    { id: 4, value: "Nunca" },
];

/*
 *SCFV
 */
arrays["scfv_faixa_etaria"] = [
    { id: 1, value: "0 a 5 anos e 11 Meses" },
    { id: 2, value: "6 anos a 14 anos e 11 Meses" },
    { id: 3, value: "15 anos a 17 anos e 11 Meses" },
    { id: 4, value: "18 a 29 anos e 11 Meses" },
    { id: 5, value: "30 a 59 anos e 11 Meses" },
    { id: 6, value: "Adulto (18 a 59 anos e 11 Meses)" },
    { id: 7, value: "Pessoa idosa (Maior que 60 anos)" },
    { id: 8, value: "Intergeracional" },
];

arrays["scfv_acesso"] = [
    { id: 1, value: "Aberto" },
    { id: 2, value: "Fechado" },
];

arrays["scfv_periodicidade"] = [
    { id: 1, value: "Diária" },
    { id: 2, value: "Semanal" },
    { id: 3, value: "Quinzenal" },
    { id: 4, value: "Mensal" },
    { id: 5, value: "Bimestral" },
];

arrays["scfv_dias_semana"] = [
    { id: 1, value: "Segunda" },
    { id: 2, value: "Terça" },
    { id: 3, value: "Quarta" },
    { id: 4, value: "Quinta" },
    { id: 5, value: "Sexta" },
    { id: 6, value: "Sábado" },
];

arrays["scfv_carater"] = [
    { id: 1, value: "Homogêneo" },
    { id: 2, value: "Heterogêneo" },
];

arrays["scfv_execucao"] = [
    { id: 1, value: "Direta" },
    { id: 2, value: "Indireta" },
];

arrays["scfv_status_vinculos"] = [
    { id: 1, value: "ATIVO" },
    { id: 2, value: "DESLIGADO" },
];

arrays["scfv_situacoes_prioritarias"] = [
    { id: 1, value: "NÃO ESTÁ EM SITUAÇÃO PRIORITÁRIA" },
    { id: 2, value: "EM SITUAÇÃO DE ISOLAMENTO" },
    { id: 3, value: "TRABALHO INFANTIL" },
    { id: 4, value: "VIVÊNCIA DE VIOLÊNCIA E/OU NEGLIGÊNCIA" },
    {
        id: 5,
        value: "FORA DA ESCOLA OU COM DEFASAGEM ESCOLAR SUPERIOR A 2 (DOIS) ANOS",
    },
    { id: 6, value: "EM SITUAÇÃO DE ACOLHIMENTO" },
    { id: 7, value: "EM CUMPRIMENTO DE MEDIDA SOCIOEDUCATIVA EM MEIO ABERTO" },
    { id: 8, value: "EGRESSOS DE MEDIDAS SOCIOEDUCATIVAS" },
    { id: 9, value: "SITUAÇÃO DE ABUSO E/OU EXPLORAÇÃO SEXUAL" },
    { id: 10, value: "COM MEDIDAS DE PROTEÇÃO DO ECA" },
    { id: 11, value: "CRIANÇAS E ADOLESCENTES EM SITUAÇÃO DE RUA" },
    {
        id: 12,
        value: "VULNERABILIDADE QUE DIZ RESPEITO ÀS PESSOAS COM DEFICIÊNCIA",
    },
    { id: 13, value: "OUTRAS" },
];
/*
 *MSE
 */
arrays["forma_execucao"] = [
    { id: 1, value: "Execução Imediata" },
    { id: 2, value: "Execução em Meio Aberto" },
    { id: 3, value: "Execução em Meio Fechado" },
];
arrays["reincidencia"] = [
    { id: 1, value: "Sim" },
    { id: 2, value: "Não" },
    { id: 3, value: "Informação indisponível" },
];
arrays["assessoramento_juridico"] = [
    { id: 1, value: "Defensor Público" },
    { id: 2, value: "Defensor Particular" },
    { id: 3, value: "Dativo" },
];
arrays["documentos_recebidos"] = [
    { id: 1, value: "Representação" },
    { id: 2, value: "Sentença" },
    { id: 3, value: "Relatórios LA/PSC anteriores" },
    { id: 4, value: "Outros" },
];
arrays["metas_pia"] = [
    { id: 1, value: "TOTALMENTE" },
    { id: 2, value: "PARCIALMENTE" },
    { id: 3, value: "INSATISFATÓRIO" },
    { id: 3, value: "NÃO FOI ATINGIDO" },
];
arrays["cumpriu_condicionalidade"] = [
    { id: 1, value: "TOTALMENTE" },
    { id: 2, value: "PARCIALMENTE" },
    { id: 3, value: "INSATISFATÓRIO" },
    { id: 3, value: "NÃO CUMPRIU" },
];

arrays["medidas_avaliacao"] = [
    { id: 1, value: "SATISFATÓRIO" },
    { id: 2, value: "PARCIALMENTE SATISFATÓRIO" },
    { id: 3, value: "INSUFICIENTE" },
];

arrays["ato_inflacional"] = [
    { id: 17, value: "ALTERAÇÃO DE SUBSTÂNCIA OU PRODUTOS ALIMENTÍCIOS" },
    { id: 1, value: "AMEAÇA" },
    { id: 19, value: "APROPRIAÇÃO INDÉBITA" },
    { id: 20, value: "ATO CONTRA A FAUNA CONSUMADO" },
    { id: 2, value: "BRIGAS NA ESCOLA COM LESÕES CORPORAIS LEVES" },
    { id: 21, value: "CONTRA O ORDENAMENTO URBANO E O PATRIMÔNIO CULTURAL" },
    { id: 22, value: "CONTRABANDO" },
    { id: 23, value: "CORRUPÇÃO" },
    { id: 24, value: "CORRUPÇÃO ATIVA" },
    { id: 25, value: "CORRUPÇÃO PASSIVA" },
    { id: 3, value: "CRIMES DE TRÂNSITO" },
    { id: 27, value: "DANO" },
    { id: 28, value: "DANO QUALIFICADO" },
    { id: 5, value: "DESACATO" },
    { id: 30, value: "DIVULGAÇÃO DE CENA DE ESTUPRO, SEXO OU PORNOGRAFIA" },
    { id: 31, value: "DO SISTEMA NACIONAL DE ARMAS" },
    { id: 4, value: "ESTELIONATO" },
    { id: 33, value: "ESTUPRO" },
    { id: 34, value: "ESTUPRO DE VULNERÁVEL" },
    { id: 35, value: "EXTORSÃO" },
    { id: 36, value: "EXTORSÃO E LESÃO CORPORAL" },
    { id: 37, value: "FALSA IDENTIDADE" },
    { id: 38, value: "FAVORECIMENTO DA PROSTITUIÇÃO" },
    { id: 6, value: "FURTO" },
    { id: 13, value: "FURTO QUALIFICADO" },
    { id: 40, value: "HOMICÍDIO CULPOSO" },
    { id: 41, value: "HOMICÍDIO DOLOSO" },
    { id: 42, value: "HOMICÍDIO QUALIFICADO" },
    { id: 43, value: "HOMICÍDIO SIMPLES" },
    { id: 7, value: "HOMICÍDIOS" },
    { id: 44, value: "INFRAÇÃO DE TRÂNSITO" },
    { id: 45, value: "INJÚRIA" },
    { id: 46, value: "INJÚRIA REAL" },
    { id: 47, value: "LATROCÍNIO" },
    { id: 48, value: "LESÃO CORPORAL" },
    { id: 49, value: "LESÃO CORPORAL GRAVE" },
    { id: 50, value: "LESÃO CORPORAL LEVE" },
    { id: 51, value: "LESÕES CORPORAIS DECORRENTES DE VIOLÊNCIA DOMÉSTICA" },
    { id: 52, value: "PERIGO PARA VIDA OU SAÚDE DE OUTREM" },
    { id: 8, value: "PORTE DE ARMAS" },
    { id: 53, value: "PORTE ILEGAL DE ARMA DE FOGO" },
    { id: 54, value: "POSSE DE DROGAS" },
    { id: 55, value: "POSSE DE DROGAS PARA CONSUMO PESSOAL" },
    { id: 56, value: "RACISMO" },
    { id: 57, value: "RECEPTAÇÃO" },
    { id: 9, value: "ROUBO" },
    { id: 15, value: "ROUBO MAJORADO" },
    { id: 16, value: "ROUBO QUALIFICADO" },
    { id: 58, value: "SEQUESTRO" },
    { id: 10, value: "TRÁFICO DE DROGAS" },
    { id: 11, value: "TRÁFICO DE DROGAS E CONDUTAS AFINS" },
    { id: 59, value: "USO DE DOCUMENTO FALSO" },
    { id: 60, value: "VIOLÊNCIA DOMÉSTICA" },
    { id: 61, value: "VIOLÊNCIA DOMÉSTICA CONTRA MULHER" },
    { id: 62, value: "NÃO INFORMADO" },
];

arrays["constituicao"] = [
    { id: 1, value: "Nuclear" },
    { id: 2, value: "Nuclear-ampliada" },
    { id: 3, value: "Ampliada" },
    { id: 4, value: "Monoparental" },
    { id: 5, value: "Recomposta" },
    { id: 6, value: "Mosaico" },
    { id: 7, value: "Unipessoal" },
    { id: 8, value: "Homoafetiva" },
];

arrays["tipo_referencia_contrareferencia"] = [
    { id: 1, value: "REFERÊNCIA" },
    { id: 2, value: "CONTRARREFERÊNCIA" },
];

arrays["origem_beneficio"] = [
    { id: 1, value: "MUNICIPAL" },
    { id: 2, value: "ESTADUAL" },
    { id: 3, value: "FEDERAL" },
    { id: 4, value: "INICIATIVA PRIVADA" },
];

arrays["programas_importacao"] = [
    { id: 1, value: "AUXILIO BRASIL (PAB)" },
    { id: 2, value: "BPC" },
];

arrays["status_acolhimento"] = [
    { id: 1, value: "ATIVO" },
    { id: 2, value: "INATIVO" },
    { id: 3, value: "EGRESSO" },
];

arrays["motivos_acolhimento"] = [
    { id: 1, value: "SITUAÇÃO DE DESEMPREGO" },
    { id: 2, value: "VULNERABILIDADE SOCIAL" },
    { id: 3, value: "VULNERABILIDADE FINANCEIRA" },
    { id: 4, value: "VÍNCULOS FAMILIARES FRAGILIZADOS" },
    { id: 5, value: "VÍNCULOS FAMILIARES ROMPIDOS" },
    { id: 6, value: "VIVÊNCIA DE VIOLÊNCIA E/OU NEGLIGÊNCIA" },
    { id: 7, value: "RUPTURA DOS VÍNCULOS FAMILIARES EM DECORRÊNCIA DE USO ABUSIVO DE SUBSTÂNCIAS PSICOATIVAS, TAIS COMO ÁLCOOL/OUTRAS DROGAS" },
    { id: 8, value: "RUPTURA DOS VÍNCULOS EM DECORRÊNCIA DE CONFLITOS" },
    { id: 9, value: "RUPTURA DOS VÍNCULOS AFETIVOS" },
    { id: 10, value: "SITUAÇÃO DE VIOLÊNCIA DOMÉSTICA" },
    { id: 11, value: "SITUAÇÃO DE ABANDONO" },
    { id: 12, value: "MÃE ACOLHIDA NO SAICA" },
    { id: 13, value: "MIGRAÇÃO" },
    { id: 14, value: "CRISE HUMANITÁRIA" },
    { id: 15, value: "SOLICITANTE DE REFÚGIO" },
    { id: 16, value: "PESSOA/FAMÍLIA EM TRÂNSITO" },
    { id: 17, value: "AUSÊNCIA DE RESIDÊNCIA" },
    { id: 18, value: "PESSOA SEM CONDIÇÕES DE AUTOSSUSTENTO" },
    { id: 19, value: "OUTROS" }
];

arrays["status_parecer"] = [
    { id: 1, value: "FAVORÁVEL" },
    { id: 2, value: "DESFAVORÁVEL" },
    // { id: 3, value: "EM ANALISE" },
];

arrays["status_liberacao"] = [
    { id: 1, value: "NEGADO" },
    { id: 2, value: "AGUARDANDO PARECER DO RESPONSÁVEL" },
    { id: 3, value: "AGUARDANDO VISITA TÉCNICA" },
    { id: 4, value: "CONCEDIDO" },
    { id: 5, value: "CANCELADO" },
    { id: 6, value: "ENTREGUE" },
    { id: 7, value: "NÃO ENTREGUE" },
    { id: 8, value: "NÃO CONCEDIDO" },
    { id: 9, value: "DEMANDA REPRIMIDA" },
];

arrays["tipo_beneficio"] = [
    { id: 1, value: "AUXÍLIO NATALIDADE" },
    { id: 2, value: "AUXÍLIO POR MORTE" },
    { id: 3, value: "KIT LIMPEZA" },
    { id: 4, value: "KIT HIGIENE PESSOAL" },
    { id: 5, value: "KIT LENÇOL SOLTEIRO" },
    { id: 6, value: "KIT LENÇOL CASAL" },
    { id: 7, value: "COLCHÃO SOLTEIRO" },
    { id: 8, value: "COLCHÃO CASAL" },
    { id: 9, value: "CESTA BÁSICA" },
];
arrays["solicitante"] = [
    { id: 1, value: "O Usuário" },
    { id: 2, value: "Outra Pessoa" },
];

arrays["beneficio_categoria"] = [
    { id: 1, value: "Pecúnia" },
    { id: 2, value: "Bens de Consumo" },
];

arrays["beneficio_fonte"] = [
    { id: 1, value: "Municipal" },
    { id: 2, value: "Estadual" },
    { id: 3, value: "Federal" },
    { id: 4, value: "Iniciativa Privada" },
    { id: 5, value: "Doação" },
];
arrays["beneficio_tipo"] = [
    { id: 1, value: "Municipal" },
    { id: 2, value: "Estadual" },
    { id: 3, value: "Federal" },
    { id: 4, value: "Iniciativa Privada" },
    { id: 5, value: "Doação" },
];

arrays["beneficio_status"] = [
    { id: 1, value: "Ativo" },
    { id: 2, value: "Inativo" },
    { id: 3, value: "Suspenso" },
];

arrays["beneficio_sexo"] = [
    { id: 1, value: "Masculino" },
    { id: 2, value: "Feminino" },
    { id: 3, value: "Ambos" },
];

/**ACOLHIMENTO CRIANÇAS E ADOLESCENTES */

arrays["acolhimento_publico_alvo"] = [
    { id: 1, value: "CRIANÇAS DE 0 A 12 ANOS INCOMPLETOS" },
    { id: 2, value: "ADOLESCENTES 12 A 18 ANOS" },
    { id: 3, value: "JOVENS ENTRE 18 E 21 ANOS" },
    { id: 4, value: "HOMENS JOVENS E ADULTOS" },
    { id: 5, value: "MULHERES JOVENS E ADULTAS" },
    { id: 6, value: "FAMÍLIAS" },
    //{ id: 7, value: "LGBTQIA+ " },
    { id: 8, value: "PESSOAS IDOSAS" },
    { id: 9, value: "PESSOAS EM SITUAÇÃO DE RUA" },
    { id: 10, value: "CRIANÇAS E ADOLESCENTES" },
    { id: 11, value: "ADOLESCENTES DO MESMO SEXO: MASCULINO" },
    { id: 12, value: "ADOLESCENTES DO MESMO SEXO: FEMININO" },
    { id: 13, value: "ADOLESCENTES INTERSEXO" },
    { id: 14, value: "ADOLESCENTES: HETEROGÊNEO" },
    { id: 15, value: "PESSOAS ADULTAS EM SITUAÇÃO DE RUA SOMENTE DO SEXO MASCULINO" },
    { id: 16, value: "PESSOAS ADULTAS EM SITUAÇÃO DE RUA SOMENTE DO SEXO FEMININO" },
    { id: 17, value: "PESSOAS ADULTAS EM SITUAÇÃO DE RUA PÚBLICO LGBTQIAPN+" },
    { id: 18, value: "PESSOAS ADULTAS EM SITUAÇÃO DE RUA HETEROGÊNEO" },
    { id: 19, value: "PESSOAS ADULTAS E FAMÍLIAS EM SITUAÇÃO DE RUA" },
    { id: 20, value: "FAMÍLIAS EM SITUAÇÃO DE RUA HETEROGÊNEO" },
    { id: 21, value: "FAMÍLIAS EM SITUAÇÃO DE RUA SOMENTE PESSOAS DO SEXO FEMININO ACOMPANHADAS OU NÃO DE CRIANÇAS E ADOLESCENTES" },
    { id: 22, value: "PESSOAS ADULTAS EM TRÂNSITO SOMENTE DO SEXO MASCULINO" },
    { id: 23, value: "PESSOAS ADULTAS EM TRÂNSITO SOMENTE DO SEXO FEMININO" },
    { id: 24, value: "PESSOAS ADULTAS EM TRÂNSITO PÚBLICO LGBTQIAPN+" },
    { id: 25, value: "FAMÍLIAS EM TRÂNSITO HETEROGÊNEO" },
    { id: 26, value: "FAMÍLIAS EM TRÂNSITO SOMENTE PESSOAS DO SEXO FEMININO ACOMPANHADAS OU NÃO DE CRIANÇAS E ADOLESCENTES" },
    { id: 27, value: "PESSOAS ADULTAS MIGRANTES/ IMIGRANTES SOMENTE DO SEXO MASCULINO" },
    { id: 28, value: "PESSOAS ADULTAS MIGRANTES/IMIGRANTES SOMENTE DO SEXO FEMININO" },
    { id: 29, value: "PESSOAS ADULTAS MIGRANTES/ IMIGRANTES PÚBLICO LGBTQIAPN+" },
    { id: 30, value: "PESSOAS ADULTAS MIGRANTES/ IMIGRANTES HETEROGÊNEO" },
    { id: 31, value: "PESSOAS ADULTAS E FAMÍLIAS MIGRANTES/ IMIGRANTES" },
    { id: 32, value: "FAMÍLIAS MIGRANTES/IMIGRANTES HETEROGÊNEO" },
    { id: 33, value: "FAMÍLIAS MIGRANTES/ IMIGRANTES SOMENTE PESSOAS DO SEXO FEMININO ACOMPANHADAS OU NÃO DE CRIANÇAS E ADOLESCENTES" },
    { id: 35, value: "OUTROS PÚBLICOS" }
];

arrays["unidade_solicitante_guarulhos"] = [
  { id: "1", value: "CONSELHO TUTELAR - BONSUCESSO" },
  { id: "2", value: "CONSELHO TUTELAR - CENTRO" },
  { id: "3", value: "CONSELHO TUTELAR - CUMBICA" },
  { id: "4", value: "CONSELHO TUTELAR - PIMENTAS I" },
  { id: "5", value: "CONSELHO TUTELAR - PIMENTAS II" },
  { id: "6", value: "CONSELHO TUTELAR - SÃO JOÃO" },
  { id: "7", value: "CONSELHO TUTELAR - TABOÃO" },
  { id: "8", value: "CRAS (INCLUIR TODAS AS UNIDADES DO MUNICÍPIO)" },
  { id: "9", value: "CREAS (INCLUIR TODAS AS UNIDADES DO MUNICÍPIO)" },
  { id: "10", value: "CENTRO POP (INCLUIR TODAS AS UNIDADES DO MUNICÍPIO)" },
  { id: "11", value: "SEAS - ABORDAGEM SOCIAL" },
  { id: "12", value: "SAI PERNOITE / OP INVERNO" },
  { id: "13", value: "SAI CENTRO" },
  { id: "14", value: "CASA DE PASSAGEM FEMININA" },
  { id: "15", value: "SAI BAMBI" },
  { id: "16", value: "ILPI (TRANSFERÊNCIA)" },
  { id: "17", value: "PAAHM - POSTO AVANÇADO DE ATENDIMENTO HUMANIZADO AOS MIGRANTES" },
  { id: "18", value: "SEPOP RUA" },
  { id: "19", value: "DEPARTAMENTO DE ASSISTÊNCIA SOCIAL DA SDAS" },
  { id: "20", value: "HOSPITAL PIMENTAS" },
  { id: "21", value: "HMU" },
  { id: "22", value: "HGG" },
  { id: "23", value: "HOSPITAL PADRE BENTO" },
  { id: "24", value: "RESIDÊNCIA TERAPÊUTICA" },
  { id: "25", value: "UPA/PA" },
  { id: "26", value: "CAPS" },
  { id: "27", value: "AÇÃO COM A VIGILÂNCIA SANITÁRIA" },
  { id: "28", value: "INCLUIR UNIDADES DE ACOLHIMENTO" },
  { id: "29", value: "INCLUIR OUTRAS UNIDADES DA REDE SOCIOASSISTENCIAL" },
  { id: "30", value: "INCLUIR OUTROS SERVIÇOS SOCIOASSISTENCIAIS" },
  { id: "31", value: "INCLUIR OUTRAS UNIDADES DA REDE INTERSETORIAL" },
  { id: "32", value: "INCLUIR SERVIÇOS DA REDE INTERSETORIAL" },
  { id: "33", value: "OUTROS" }
];

arrays["acolhimento_origem_solicitacao"] = [
    { id: 1, value: "A PRÓPRIA PESSOA" },
    { id: 2, value: "FAMÍLIA" },
    { id: 3, value: "ORDEM JUDICIAL" },
    { id: 4, value: "MINISTÉRIO PÚBLICO" },
    { id: 5, value: "VARA DA INFÂNCIA E JUVENTUDE" },
    { id: 6, value: "SISTEMA PRISIONAL" },
    { id: 7, value: "SISTEMA SOCIOEDUCATIVO EM MEIO FECHADO" },
    { id: 8, value: "ÓRGÃO DE DEFESA DE DIREITOS" },
    { id: 9, value: "CREAS" },
    { id: 10, value: "CENTRO POP" },
    { id: 11, value: "UNIDADE GESTORA DA POLÍTICA DE ASSISTÊNCIA SOCIAL" },
    { id: 12, value: "UNIDADE DE ACOLHIMENTO" },
    { id: 13, value: "UNIDADE DA REDE SOCIOASSISTENCIAL" },
    { id: 14, value: "SERVIÇO DA REDE SOCIOASSISTENCIAL" },
    { id: 15, value: "UNIDADE DA REDE INTERSETORIAL" },
    { id: 16, value: "SERVIÇO DA REDE INTERSETORIAL" },
    { id: 17, value: "OUTROS" }
];


arrays["acolhimento_status"] = [
    { id: 1, value: "ABERTO" },
    { id: 2, value: "EM ACOLHIMENTO" },
    { id: 3, value: "FINALIZADO" },
    { id: 4, value: "INATIVO" },
];

arrays["acolhimento_observacao_visita_aspectos"] = [
    { id: 1, value: "ACEITAÇÃO" },
    { id: 2, value: "INTOLERANCIA" },
    { id: 3, value: "RIGIDEZ" },
    { id: 4, value: "AFETIVIDADE" },
    { id: 5, value: "REJEIÇÃO" },
    { id: 6, value: "ESPONTANEIDADE" },
    { id: 7, value: "DISTANCIAMENTO AFETIVO" },
    { id: 8, value: "DEMONSTRA VINCULAÇÃO AFETIVA" },
    { id: 9, value: "COMPREENSÃO" },
    { id: 10, value: "FALTA DE INICIATIVA" },
];
arrays["acolhimento_observacao_visita"] = [
    { id: 1, value: "SATISFAÇÃO" },
    { id: 2, value: "FAZ POR OBRIGAÇÃO" },
    { id: 3, value: "TRISTEZA" },
    { id: 4, value: "PESAR" },
    { id: 5, value: "CULPA" },
];

arrays["acolhimento_naturezas"] = [
    { id: 1, value: "GOVERNAMENTAL" },
    { id: 2, value: "NÃO-GOVERNAMENTAL" },
];

arrays["acolhimento_solicitantes"] = [
    { id: 1, value: "CONSELHO TUTELAR" },
    { id: 2, value: "JUIZADO" },
    { id: 3, value: "PROMOTORIA" },
    { id: 4, value: "OUTROS" },
];

arrays["acolhimento_anterior"] = [
    { id: 1, value: "RESIDIA SÓ" },
    { id: 2, value: "ESTAVA EM OUTRO SERVIÇO DE ACOLHIMENTO" },
    { id: 3, value: "RESIDIA COM FAMILIARES" },
    { id: 4, value: "ESTAVA EM SITUAÇÃO DE RUA" },
    { id: 5, value: "NÃO SOUBE INFORMAR" },
    { id: 6, value: "ESTAVA EM TRÂNSITO/FLUXO MIGRATÓRIO" },
    { id: 7, value: "SITUAÇÃO DE REFÚGIO" },
    { id: 8, value: "SITUAÇÃO DE DESABRIGO" },
    { id: 9, value: "OUTRO" },
];

arrays["acolhimento_solicitantes_idoso"] = [
    { id: 1, value: "O PRÓPRIO" },
    { id: 2, value: "ORDEM JUDICIAL" },
    { id: 3, value: "MINISTÉRIO PÚBLICO" },
    { id: 4, value: "FAMÍLIA" },
    { id: 5, value: "CREAS" },
    { id: 6, value: "CONSELHO DE DIREITO" },
    { id: 7, value: "OUTRO" },
];

arrays["medida_protetiva_aplicada"] = [
    { id: 1, value: "PELA PRIMEIRA VEZ" },
    { id: 2, value: "PELA SEGUNDA VEZ" },
    { id: 3, value: "PELA TERCEIRA VEZ" },
    { id: 4, value: "ACIMA DE TRÊS VEZES" },
];
arrays["acolhimento_documentacao"] = [
    { id: 1, value: "TERMO DE ACOLHIMENTO (DO CONSELHO TUTELAR)" },
    { id: 2, value: "CERTIDÃO DE NASCIMENTO" },
    { id: 3, value: "CARTEIRA DE IDENTIDADE NACIONAL - CIN" },
    { id: 4, value: "CARTÃO DE VACINA" },
    { id: 5, value: "CPF" },
    { id: 6, value: "CNIS" },
    { id: 7, value: "CARTÃO DO SUS" },
    { id: 8,
        value: "RELATÓRIO DE SAÚDE PRESCRIÇÃO MÉDICA ANTERIOR AO ACOLHIMENTO",
    },
    { id: 9, value: "HISTÓRICO ESCOLAR" },
    { id: 10, value: "DECLARAÇÃO DE TRANSFERÊNCIA ESCOLAR" },
    { id: 11, value: "BOLETIM DE OCORRÊNCIA" },
    { id: 12, value: "TERMO DE GUARDA E RESPONSABILIDADE" },
    { id: 13, value: "GUIA DE DESLIGAMENTO" },
    { id: 14, value: "DOCUMENTAÇÕES SOBRE ESCOLARIDADE" },
    { id: 15, value: "GUIA DE ACOLHIMENTO" },
    { id: 16, value: "OUTROS" },
];

arrays["acolhimento_documentacao_idoso"] = [
    { id: 1, value: "CERTIDÃO DE NASCIMENTO/CASAMENTO" },
    { id: 2, value: "CARTEIRA DE IDENTIDADE NACIONAL - CIN" },
    { id: 3, value: "CARTÃO DE VACINA" },
    { id: 4, value: "CPF" },
    { id: 5, value: "CNIS" },
    { id: 6, value: "CARTÃO DO SUS" },
    { id: 7, value: "RELATÓRIO DE SAÚDE PRESCRIÇÃO MÉDICA ANTERIOR AO ACOLHIMENTO" },
    { id: 8, value: "TITULO DE ELEITOR" },
    { id: 9, value: "CERTIFICADO DE RESERVISTA" },
    { id: 10, value: "CARTEIRA DE TRABALHO E PREVIDÊNCIA SOCIAL - CTPS" },
    { id: 11, value: "LAUDOS MÉDICOS" },
    { id: 12, value: "EXAMES MÉDICOS" },
    { id: 13, value: "OUTROS" },
    { id: 14, value: "BOLETIM DE OCORRÊNCIA" },
    { id: 15, value: "GUIA DE ACOLHIMENTO" },
];

arrays["acolhimento_documentacao_acao"] = [
    { id: 2, value: "RECEBIDA – ORIGINAL" },
    { id: 3, value: "RECEBIDA – CÓPIA " },
    { id: 4, value: "DEVOLVIDA NO DESLIGAMENTO " },
    { id: 5, value: "A SER PROVIDENCIADA " },
    { id: 6, value: "NÃO POSSUI" },
    { id: 7, value: "RECEBIDA SEGUNDA VIA" },
    { id: 8, value: "RECEBIDO PROTOCOLO DE REQUISIÇÃO" },
];

arrays["acolhimento_pessoa_imped_visita"] = [
    { id: 1, value: "FILHOS" },
    { id: 2, value: "CÔNJUGE" },
    { id: 3, value: "OUTROS FAMILIARES" },
    { id: 4, value: "PESSOA DE REFERÊNCIA SEM LAÇOS CONSANGUÍNEOS" },
];

arrays["acolhimento_fam_relacao_idoso"] = [
    { id: 1, value: "HARMONIOSA" },
    { id: 2, value: "INEXISTENTE" },
    { id: 3, value: "CONFLITUOSA" },
    { id: 4, value: "PRESERVADO" },
    { id: 5, value: "FRAGILIZADO" },
    { id: 6, value: "ROMPIDO" },
    { id: 7, value: "SEM REFERÊNCIA FAMILIAR" },
];

arrays["acolhimento_tomada_atitude"] = [
    { id: 1, value: "COLOCAÇÃO DE LIMITES" },
    { id: 2, value: "COM EQUILÍBRIO" },
    { id: 3, value: "COM AGRESSIVIDADE" },
    { id: 4, value: "CUIDADOS BÁSICOS COM A SAÚDE, COM  ALIMENTAÇÃO." },
    { id: 5, value: "BRINCA COM A CRIANÇA" },
];

arrays["acolhimento_tipo_relacao"] = [
    { id: 1, value: "ACEITAÇÃO" },
    { id: 2, value: "MEDO" },
    { id: 3, value: "RECUSA" },
    { id: 4, value: "AMEAÇA" },
    { id: 5, value: "DESCONFIANÇA" },
    { id: 6, value: "REVOLTA" },
    { id: 7, value: "CONFIANÇA" },
    { id: 8, value: "DEMONSTRA VINCULAÇÃO AFETIVA" },
];

arrays["acolhimento_doencas_infantis"] = [
    { id: 1, value: "SARAMPO" },
    { id: 2, value: "CATAPORA" },
    { id: 3, value: "CAXUMBA" },
    { id: 4, value: "RUBÉOLA" },
    { id: 5, value: "OUTRAS" },
];

arrays["acolhimento_brinca_com_pessoas"] = [
    { id: 1, value: "MAIS VELHA" },
    { id: 2, value: "MAIS NOVA" },
    { id: 3, value: "MESMA IDADE" },
];

arrays["acolhimento_local_origem"] = [
    { id: 1, value: "O PRÓPRIO MUNICÍPIO" },
    { id: 2, value: "OUTRO MUNICÍPIO DA REGIÃO METROPOLITANA" },
    { id: 3, value: "CAPITAL DO ESTADO" },
    { id: 4, value: "OUTRO MUNICÍPIO DO ESTADO" },
    { id: 5, value: "OUTRO ESTADO" },
    { id: 6, value: "OUTRO PAÍS" },
    { id: 7, value: "NÃO INFORMADO" },
];

arrays["acolhimento_aspectos_pessoais"] = [
    { id: 1, value: "TÍMIDO" },
    { id: 2, value: "DESEMBARAÇADO" },
    { id: 3, value: "SEGURO" },
    { id: 4, value: "INSEGURO" },
    { id: 5, value: "CARINHOSO" },
    { id: 6, value: "SECO NAS RELAÇÕES" },
    { id: 7, value: "PACIENTE" },
    { id: 8, value: "IMPACIENTE" },
    { id: 9, value: "TRISTE" },
    { id: 10, value: "ALEGRE" },
    { id: 11, value: "ANSIOSO" },
    { id: 12, value: "TRANQÜILO" },
    { id: 13, value: "CALMO" },
    { id: 14, value: "AGITADO" },
    { id: 15, value: "CORAJOSO" },
    { id: 16, value: "MEDROSO" },
    { id: 17, value: "POSSESSIVO  " },
    { id: 18, value: "DESPRENDIDO" },
    { id: 19, value: "SATISFEITO" },
    { id: 20, value: "INSATISFEITO " },
    { id: 21, value: "RÍGIDO" },
    { id: 22, value: "FLEXÍVEL" },
    { id: 23, value: "CURIOSO " },
    { id: 24, value: "OBSERVADOR" },
    { id: 25, value: "ORGANIZADO" },
    { id: 26, value: "DESORGANIZADO" },
    { id: 27, value: "CIUMENTO" },
    { id: 28, value: "INDIFERENTE " },
    { id: 29, value: "OBEDIENTE" },
    { id: 30, value: "DESOBEDIENTE" },
    { id: 31, value: "RARAMENTE TERMINA AS TAREFAS" },
    { id: 32, value: "EVITA COMPANHEIROS" },
    { id: 33, value: "PRESTATIVO" },
    { id: 34, value: "NÃO GOSTA DE FAZER FAVORES" },
    {
        id: 35,
        value: "TEM HÁBITOS DE CORTESÍA (CUMPRIMENTA, DESPEDE-SE, AGRADECE etc.)",
    },
    {
        id: 36,
        value: "USA DE  ENGANO OU MENTIRA PARA CONSEGUIR  AS COISAS QUE DESEJA",
    },
];

arrays["acolhimento_aspectos_pessoais_idoso"] = [
    { id: 1, value: "INTROVERTIDO" },
    { id: 2, value: "EXTROVERTIDO" },
    { id: 3, value: "INSEGURO" },
    { id: 4, value: "SEGURO" },
    { id: 5, value: "INDIFERENTE" },
    { id: 6, value: "AFETUOSO" },
    { id: 7, value: "IMPACIENTE" },
    { id: 8, value: "PACIENTE" },
    { id: 9, value: "TRISTE" },
    { id: 10, value: "ALEGRE" },
    { id: 11, value: "ANSIOSO" },
    { id: 12, value: "TRANQÜILO" },
    { id: 13, value: "CALMO" },
    { id: 14, value: "TEMEROSO" },
    { id: 15, value: "DESTEMIDO" },
    { id: 16, value: "AGRESSIVO" },
    { id: 17, value: "PASSIVO" },
    { id: 18, value: "POSSESSIVO" },
    { id: 19, value: "ALTRUÍSTA" },
    { id: 20, value: "INSATISFEITO " },
    { id: 21, value: "SATISFEITO" },
    { id: 22, value: "RÍGIDO" },
    { id: 23, value: "FLEXÍVEL " },
    { id: 24, value: "APÁTICO" },
    { id: 25, value: "CURIOSO" },
    { id: 26, value: "DISTRAÍDO" },
    { id: 27, value: "OBSERVADOR" },
    { id: 28, value: "DESORGANIZADO" },
    { id: 29, value: "OBEDIENTE" },
    { id: 30, value: "ORGANIZADO" },
    { id: 31, value: "CIUMENTO" },
    { id: 32, value: "DESPREENDIDO" },
    { id: 33, value: "DESOBEDIENTE" },
    { id: 34, value: "OBEDIENTE" },
    { id: 35, value: "NÃO PRESTATIVO" },
    { id: 36, value: "PRESTATIVO" },
    { id: 37, value: "RARAMENTE TERMINA AS TAREFAS" },
    { id: 38, value: "EVITA COMPANHIAS" },
    {
        id: 39,
        value: "POSSUI HÁBITOS DE CORTESIA (CUMPRIMENTA, DESPEDE-SE, AGRADECE",
    },
];

arrays["autores_violencia_violacao"] = [
    { id: 1, value: "MÃE" },
    { id: 2, value: "PAI" },
    { id: 3, value: "MADRASTA" },
    { id: 4, value: "PADRASTO" },
    { id: 5, value: "IRMÃ(O)" },
    { id: 6, value: "TIA(O)" },
    { id: 7, value: "PRIMA(O)" },
    { id: 8, value: "AVÓ" },
    { id: 9, value: "AVÔ" },
    { id: 10, value: "NÃO SE APLICA" },
    { id: 11, value: "OUTRO" },
];

arrays["equipamento_locomocao"] = [
    { id: 1, value: "MULETA" },
    { id: 2, value: "CADEIRA DE RODAS" },
    { id: 3, value: "CADEIRA DE RODAS PARA BANHO" },
    { id: 4, value: "ANDADOR" },
    { id: 5, value: "BARRAS DE APOIO" },
    { id: 6, value: "OUTROS" },
];

arrays["intituicao_psiquiatrica"] = [
    { id: 1, value: "PÚBLICA" },
    { id: 2, value: "PARTICULAR" },
];

arrays["idoso_pessoa_administra_auxilio"] = [
    { id: 1, value: "SIM, SOZINHO" },
    { id: 2, value: "SIM, COM AUXÍLIO DE OUTRAS PESSOAS" },
    { id: 3, value: "NÃO" },
];

arrays["idoso_vinculo_acompanhamento_acao"] = [
    { id: 1, value: "ACEITAÇÃO" },
    { id: 2, value: "INTOLERANCIA" },
    { id: 3, value: "RIGIDEZ" },
    { id: 4, value: "AFETIVIDADE" },
    { id: 5, value: "REJEIÇÃO" },
    { id: 6, value: "ESPONTANEIDADE" },
    { id: 7, value: "DISTACIAMENTO AFETIVO" },
    { id: 8, value: "DEMONSTRA VINVULAÇÃO AFETIVA" },
    { id: 9, value: "COMPREENSÃO" },
    { id: 10, value: "FALTA DE INICIATIVA" },
];

arrays["religiao_acolhimento"] = [
    { id: 1, value: "CATÓLICA" },
    { id: 2, value: "EVANGÉLICA" },
    { id: 3, value: "ESPÍRITA" },
    { id: 4, value: "CANDOMBLÉ" },
    { id: 5, value: "UMBANDA" },
    { id: 6, value: "ISLÃ" },
    { id: 7, value: "AGNÓSTICO" },
    { id: 8, value: "OUTRA" },
    { id: 9, value: "NÃO INFORMADA" }
];

arrays["motivo_finalizacao_atividade_acolhimento"] = [
    { id: "1", value: "SUPERAÇÃO DA MOTIVAÇÃO INICIAL" },
    { id: "2", value: "RECÂMBIO" },
    { id: "3", value: "EVASÃO" },
    { id: "4", value: "POR SOLICITAÇÃO DA PRÓPRIA PESSOA" },
    { id: "5", value: "NÃO ADESÃO À PROPOSTA DA ATIVIDADE" },
    { id: "6", value: "FALECIMENTO" },
    { id: "7", value: "TRANSFERÊNCIA PARA OUTRA ATIVIDADE" },
    { id: "8", value: "ATIVIDADE FINALIZADA" },
    { id: "9", value: "OUTRO" }
];

arrays["motivo_desligamento_acolhimento"] = [
    { id: 1, value: "SUPERAÇÃO DA MOTIVAÇÃO INICIAL" },
    { id: 2, value: "RECÂMBIO" },
    { id: 3, value: "EVASÃO" },
    { id: 4, value: "POR SOLICITAÇÃO DA PRÓPRIA PESSOA" },
    { id: 5, value: "RETORNO À FAMÍLIA" },
    { id: 6, value: "RECUSA DO SERVIÇO" },
    { id: 7, value: "NÃO ADESÃO À PROPOSTA DO SERVIÇO" },
    { id: 8, value: "DESACOLHIMENTO POR INDISCIPLINA/QUEBRA DE NORMAS" },
    { id: 9, value: "FALECIMENTO" },
    { id: 10, value: "TRANSFERÊNCIA PARA OUTRO SERVIÇO" },
    { id: 11, value: "DESACOLHIMENTO COM RESTRIÇÃO" },
    { id: 12, value: "AGRESSÃO FÍSICA" },
    { id: 13, value: "USO DE DROGAS NO SERVIÇO" },
    { id: 14, value: "ROUBO/FURTO" },
    { id: 15, value: "DEPREDAÇÃO" },
    { id: 16, value: "AMEAÇA" },
    { id: 17, value: "OUTRO" }
];

arrays["idoso_interesse_atividades"] = [
    {
        id: 1,
        value: "DE LAZER/RECREATIVAS (PASSEIOS, JOGOS, FILMES, BRINCADEIRAS) ",
    },
    {
        id: 2,
        value: "FESTIVAS (BAILES, CHÁS, COMEMORAÇÃO DE ANIVERSÁRIOS E DATAS FESTIVAS) ",
    },
    {
        id: 3,
        value: "FÍSICAS E ESPORTIVAS (ALONGAMENTOS, GINÁSTICAS, CAMINHADAS, FISIOTERAPIA, DANÇA)",
    },
    {
        id: 4,
        value: "CULTURAIS (CINEMA, MUSEU, TEATRO, SERESTAS, SARAU, RECITAIS, OFICINAS LÚDICAS)",
    },
    {
        id: 5,
        value: "ENCONTROS RELIGIOSOS (MISSAS, CULTOS, CERIMÔNIA ECUMÊNICA, LEITURA BÍBLICA)",
    },
    {
        id: 6,
        value: "OCUPACIONAIS (TRABALHOS MANUAIS, OFICINAS DE MEMÓRIA, MUSICOTERAPIA, DINÂMICAS DE GRUPO, PALAVRAS CRUZADAS, LEITURA)",
    },
    {
        id: 7,
        value: "SOCIOEDUCATIVAS (PALESTRAS, CAMPANHAS, ASSEMBLEIAS, ENCONTROS DE DISCUSSÃO REFLEXIVA)",
    },
    {
        id: 8,
        value: "EDUCACIONAIS/PROFISSIONALIZANTES (AUMENTO DA ESCOLARIDADE, ALFABETIZAÇÃO, CURSOS)",
    },
    { id: 9, value: "TRABALHO/AÇÕES VOLUNTÁRIAS" },
    { id: 10, value: "NÃO TEM INTERESSE EM NENHUMA ATIVIDADE" },
];

arrays["medidas_antes_aplicadas"] = [
    {
        id: 1,
        value: "ENCAMINHAMENTO AOS PAIS OU RESPONSÁVEL, MEDIANTE TERMO DE RESPONSABILIDADE",
    },
    { id: 2, value: "ORIENTAÇÃO, APOIO ACOMPANHAMENTO TEMPORÁRIO" },
    {
        id: 3,
        value: "MATRÍCULA E FREQUÊNCIA OBRIGATÓRIAS EM ESTABELECIMENTO OFICIAL DE ENSINO FUNDAMENTAL",
    },
    {
        id: 4,
        value: "INCLUSÃO EM PROGRAMA COMUNITÁRIO OU OFICIAL DE AUXÍLIO À FAMÍLIA, À CRIANÇA E AO ADOLESCENTE",
    },
    {
        id: 5,
        value: "REQUISIÇÃO DE TRATAMENTO MÉDICO, PSICOLÓGICO OU PSIQUIÁTRICO, EM REGIME HOSPITALAR OU AMBULATORIAL",
    },
    {
        id: 6,
        value: "INCLUSÃO EM PROGRAMA OFICIAL OU COMUNITÁRIO DE AUXÍLIO, ORIENTAÇÃO E TRATAMENTO A ALCOÓLATRAS E TOXICÔMANOS",
    },
    { id: 7, value: "ACOLHIMENTO INSTITUCIONAL" },
    { id: 8, value: "INCLUSÃO EM PROGRAMA DE ACOLHIMENTO FAMILIAR" },
    { id: 9, value: "COLOCAÇÃO EM FAMÍLIA SUBSTITUTA" },
];

arrays["acolhimento_motivo"] = [
    { id: 1, value: "ENTREGA VOLUNTÁRIA" },
    { id: 2, value: "ORFANDADE" },
    { id: 3, value: "ABANDONO" },
    { id: 4, value: "VIOLÊNCIA FÍSICA" },
    { id: 5, value: "VIOLÊNCIA PSICOLÓGICA" },
    { id: 6, value: "ABUSO SEXUAL" },
    { id: 7, value: "EXPLORAÇÃO SEXUAL" },
    { id: 8, value: "TRABALHO INFANTIL" },
    { id: 9, value: "SITUAÇÃO DE RUA/MENDICÂNCIA" },
    { id: 10, value: "AUSÊNCIA DOS PAIS / RESPONSÁVEIS POR DOENÇA" },
    {
        id: 11,
        value: "AUSÊNCIA DOS PAIS / RESPONSÁVEIS POR PRISÃO OU MSE DE INTERNAÇÃO",
    },
    { id: 12, value: "AMEAÇA DE MORTE DOS PAIS / RESPONSÁVEIS" },
    { id: 13, value: "PAIS / RESPONSÁVEIS USUÁRIOS ABUSIVOS DE ÁLCOOL" },
    { id: 14, value: "PAIS / RESPONSÁVEIS USUÁRIOS ABUSIVOS DE DROGAS" },
    { id: 15, value: "PAIS / RESPONSÁVEIS COM ALGUM TIPO DE DEFICIÊNCIA" },
    {
        id: 16,
        value: "PAIS / RESPONSÁVEIS COM TRANSTORNO MENTAL / SOFRIMENTO PSÍQUICO",
    },
    { id: 17, value: "CONFLITO FAMILIAR" },
    { id: 18, value: "NEGLIGÊNCIA" },
    { id: 20, value: "ENTREGA ILEGAL PARA ADOÇÃO" },
    { id: 19, value: "OUTRO" },
];

arrays["reincidencia_acolhimento"] = [
    { id: 1, value: "SIM" },
    { id: 2, value: "NÃO" },
];

arrays["acolhimento_motivo_idoso"] = [
    { id: 1, value: "VIVÊNCIA DE VIOLÊNCIA E/OU NEGLIGÊNCIA" },
    { id: 2, value: "VÍNCULOS FAMILIARES ROMPIDOs" },
    { id: 3, value: "SITUAÇÃO DE RUA E/OU ABANDONO" },
    { id: 4, value: "AUSÊNCIA DE PESSOA RESPONSÁVEL PELOS CUIDADOS DA PESSOA IDOSA" },
    { id: 5, value: "OUTROS" },
];

arrays["paises_acolhimento"] = [
    { id: 1, value: "Brasil" },
    { id: 2, value: "Argentina" },
    { id: 3, value: "Estados Unidos" },
    { id: 4, value: "Canadá" },
    { id: 5, value: "Portugal" },
    { id: 6, value: "Espanha" },
    { id: 7, value: "Alemanha" },
    { id: 8, value: "França" },
    { id: 9, value: "Reino Unido" },
    { id: 10, value: "Itália" },
    { id: 11, value: "Japão" },
    { id: 12, value: "China" },
    { id: 13, value: "Índia" },
    { id: 14, value: "México" },
    { id: 15, value: "Uruguai" },
    { id: 16, value: "Paraguai" },
    { id: 17, value: "Chile" },
    { id: 18, value: "Bolívia" },
    { id: 19, value: "Peru" },
    { id: 20, value: "Colômbia" },
    { id: 21, value: "Outros" },
    { id: 22, value: "Situação de Refúgio" },
    { id: 23, value: "Apátrida" },
    { id: 24, value: "Asilado" },
];

arrays["idiomas"] = [
    { id: 1, value: "Português" },
    { id: 2, value: "Inglês" },
    { id: 3, value: "Espanhol" },
    { id: 4, value: "Francês" },
    { id: 5, value: "Árabe" },
    { id: 6, value: "Persa" },
    { id: 7, value: "Outro" },
];

arrays["acolhimento_grau_dependencia"] = [
    {
        id: 1,
        value: "GRAU DE DEPENDÊNCIA I: PESSOAS IDOSAS INDEPENDENTES, MESMO QUE REQUEIRAM USO DE EQUIPAMENTO DE AUTOAJUDA.",
    },
    {
        id: 2,
        value: "GRAU DE DEPENDÊNCIA II: PESSOAS IDOSAS COM DEPENDÊNCIA EM ATÉ TRÊS ATIVIDADES DE AUTOCUIDADO PARA A VIDA DIÁRIA.",
    },
    {
        id: 3,
        value: "GRAU DE DEPENDÊNCIA III: PESSOAS IDOSAS COM DEPENDÊNCIA QUE REQUEIRAM ASSISTÊNCIA EM TODAS AS ATIVIDADES DE AUTOCUIDADO PARA A VIDA DIÁRIA E/OU COM COMPROMETIMENTO COGNITIVO.",
    },
];

arrays["acolhimento_suposto_ator_violencia"] = [
    { id: 1, value: "CÔNJUGE" },
    { id: 2, value: "FILHOS" },
    { id: 3, value: "OUTROS FAMILIARES" },
    { id: 4, value: "PESSOA DE REFERÊNCIA SEM LAÇOS CONSANGUÍNEOS" },
];

arrays["idoso_interditada"] = [
    { id: 1, value: "NÃO" },
    { id: 2, value: "PARCIALMENTE" },
    { id: 3, value: "TOTALMENTE" },
];

arrays["outras_opcoes_filtro_familia"] = [
    { id: 1, value: "TRABALHO INFANTIL NA FAMÍLIA" },
    { id: 2, value: "FAMÍLIAS MIGRANTES" },
    { id: 3, value: "FAMÍLIAS EM SITUAÇÃO DE RUA" },
    { id: 4, value: "FAMÍLIAS COM RENDA PER CAPITA ATÉ R$ 100,00" },
    {
        id: 5,
        value: "FAMÍLIAS COM CADÚNICO ATUALIZADO A HÁ MAIS DE 2 ANOS",
    },
    {
        id: 6,
        value: "RESPONSÁVEL SEM NIS",
    },
];

arrays["dark_mode_map"] = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#242f3e" }],
    },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#263c3f" }],
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ color: "#6b9a76" }],
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#38414e" }],
    },
    {
        featureType: "road",
        elementType: "geometry.stroke",
        stylers: [{ color: "#212a37" }],
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#9ca5b3" }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#746855" }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#1f2835" }],
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ color: "#f3d19c" }],
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#2f3948" }],
    },
    {
        featureType: "transit.station",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#17263c" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#515c6d" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#17263c" }],
    },
];

arrays["origem_nome_social"] = [
    { id: 1, value: "PRESENTE NO RG" },
    { id: 2, value: "INFORMADO PELO USUÁRIO" },
];

arrays["beneficio_periodicidade"] = [
    { id: 1, value: "Semanal" },
    { id: 2, value: "Quinzenal" },
    { id: 3, value: "Mensal" },
    { id: 4, value: "Bimestral" },
    { id: 5, value: "Não programada" },
];

arrays["ind_trans"] = [
    { id: 1, value: "Sim, a pessoa é trans" },
    { id: 2, value: "Sim, a pessoa é travesti" },
    { id: 3, value: "Não" },
];

arrays["tipo_identidade_genero"] = [
    { id: 1, value: "Feminina" },
    { id: 2, value: "Masculina" },
    { id: 3, value: "Não binário/a" },
];



export default arrays;
